const pt = {
  dateStartBeforeDateFinal: "A data início não pode ser maior que a data final",
  applyFilter: "Aplicar Filtro",
  rangeDateInfo: "Se nenhuma data for informada (inicial ou final) o relatório irá exibir os dados de todo o período, a partir da data de cadastro do jogador.",
  seeNotification: "Ver",
  viewed: "Visto",
  notViewed: "Não visto",
  wantToDeleteThisMessage: "Deseja deletar esta mensagem?",
  deleteMessage: "Deletar mensagem",
  editMessage: "Editar mensagem",
  addNotificationText: "Por padrão, o sistema envia mensagens para todos os jogadores. Para enviar mensagens para jogadores específicos, busque pelo nome ou ID abaixo",
  seeSelectedUsers: "Ver usuários selecionados (ID's)",
  newMessage: "Nova mensagem",
  selectTags: "Selecionar Tags",
  massImportAffiliatesMIN: "É preciso ter ao menos 1 (um) usuário para importar",
  massImportAffiliatesMAX: "Só é possível importar 1000 (mil) afiliados por vez",
  massImportAffiliatesRequiredColumns: `Máximo de 1000 afiliados por importação.<br> As colunas "local_manager_id", "login", "name" e "password" são obrigatórios para a importação de afiliados em massa.`,
  massImportAffiliates: "Importar afiliados em massa",
  importAffiliates: "Importar Afiliados",
  someErrorsWereFound: "Alguns erros foram encontrados",
  operationLog: "Log da operação",
  noTagsCreated: "Não existem tags criadas.",
  prizeFreespinsQtt: "Qtd. Prêmios freespins",
  prizeFreespinsAmount: "Total Prêmios freespins",
  casinoReferenceDay: "Dia de Referência",
  prizeRefundAmount: "Total Reembolso de prêmios",
  prizeRefundQtt: "Qtd. Reembolso de prêmios",
  betRefundAmount: "Total Reembolso de apostas",
  betRefundQtt: "Qtd. Reembolso de apostas",
  gameId: "ID Jogo",
  registeredUsers: "Usuários cadastrados",
  usersByCampaign: "Usuários por campanha",
  wonBet: "Ganho",
  lostBet: "Perdido",
  resultDate: "Data do Resultado",
  numberOfGames: "N° de Jogos",
  multiplier: "Multiplicador",
  consultedOn: "Consultado em",
  irreversibleAction: "Essa ação é irreversível.",
  tagsConfig: "Tags",
  createTag: "Criar tag",
  createNewTag: "Criar nova tag",
  seeTags: "Ver tags",
  playerTags: "Tags do jogador",
  addTag: "Adicionar tag",
  addTags: "Adicionar tags",
  removeTags: "Excluir tag | Excluir tag | Excluir tags",
  confirmRemoveTagText: "Tem certeza que deseja excluir a(s) tag(s) selecionadas?",
  maxTagsReached: "Número máximo de 5 tags atingido",
  noTagsAvailable: "Nenhuma tag disponível",
  tipRemoveTag: "Dica: Clique na tag que deseja remover deste jogador",
  tipSelectMaxTags: "Selecione até {maxQtyPlayerTags} tags",
  yourTags: "Suas tags",
  manageTags: "Gerenciar tags",
  editTags: "Editar tags",
  color: "Cor",
  selectColor: "Selecione uma cor",
  selectTag: "Selecione uma tag",
  noTagFound: "Nenhuma tag encontrada",
  create: "Criar",
  insertTitle: "Insira um título",
  seeGames: "Ver jogos",
  irreversibleActionExemptPlayer:
    "Esta ação é irreversível: O jogador vinculado não poderá ser editado ou removido.",
  playerName: "Nome do Jogador: {playerName}",
  searchExemptPlayer: "Pesquisar Jogador Isento",
  searchAffiliate: "Pesquisar Afiliados(s)",
  linkExemptPlayerBtn: "Vincular jogador isento",
  linkAffiliateExemptPlayerBtn: "Vincular a um Jogador Isento",
  linkExemptPlayerAffiliates: "Vincular Jogador Isento a Afiliado(s)",
  linkAffiliateExemptPlayer: "Vincular Afiliado a um Jogador Isento",
  idTransaction: "ID Transação",
  typePix: "Tipo de Pix",
  valueCpa: "Valor CPA",
  loadingData: "Carregando dados...",
  cpaLabel: "CPA",
  playerId: "ID Jogador",
  details: "Detalhes",
  cpaValue: "CPA Valor",
  cpaType: "CPA Tipo",
  lclManager: "Ger. Local",
  regManager: "Ger. Regional",
  percent: "Percentual",
  noCommission: "Sem comissão",
  chooseGroupByOption:
    "É necessário escolher uma opção em Agrupar por: jogo ou provedor",
  lobbyAll: "Lobby: Todos",
  newCasino: "Novo Cassino",
  providerCategories: "Categorias do Provedor",
  gameSettings: "Configurações do jogo",
  chooseAtLeastOneCategoryOrProvider:
    "É necessário escolher ao menos uma categoria customizada ou um provedor",
  casinoVolatility: `A volatilidade é fornecida pelos provedores de jogos. 
  Esta é utilizada para indicar aos jogadores a frequência 
  com que o slot atribui pagamento, e quão altos poderão 
  esperar que sejam os pagamentos.`,
  casinoRTP: `RTP: O retorno ao jogador, ou RTP, em qualquer jogo, 
  é a percentagem esperada de valores de aposta que 
  um jogo específico retornará ao jogador ao longo de 
  um período de tempo.`,
  high: "Alto",
  "very-high": "Muito alto",
  medium: "Médio",
  "medium-high": "Médio-alto",
  low: "Baixo",
  "low-medium": "Médio-baixo",
  payout: "Pagamento",
  guestBy: "Exibir 'Indicado por'",
  volatilityRating: "Volatilidade",
  categoryWeight: "Peso da Categoria",
  categoryWeightTxt:
    "O 'peso da categoria' determina o posicionamento de uma categoria na listagem do cassino. Por exemplo: Uma categoria 'Jogos populares' que tem o peso de 50 aparecerá na lista antes de uma categoria 'Novos jogos' que tem o peso de 40. O peso de uma categoria pode ir de 0 a 999.",
  customCategories: "Categorias Customizadas",
  systemGameStatus: "Status do jogo no sistema",
  visibleGameTxt: `
    <span class="mb-4">O jogo estará sendo exibido se:</span>
    <ul>
      <li>Estiver inserido em ao menos uma categoria</li>
      <li>Ao menos uma categoria deve estar ativa</li>
      <li>O status do jogo no sistema deve estar ativo</li>
    </ul>
  `,
  noDescription: "Sem descrição",
  selectCategory: "Selecionar categoria customizada",
  gameDisplayed: "Jogo exibido",
  casinoTheme: "Tema",
  verticalCategory: "Categoria vertical",
  showLess: "mostrar menos",
  showMore: "mostrar mais",
  filterByVerticalCategory: "Filtrar por Categoria do Provedor",
  filterByCasinoTheme: "Filtrar por Tema",
  readLess: "Ler menos",
  readMore: "Ler mais",
  lobbyCasino: "Lobby: Cassino",
  lobbyCasinoLive: "Lobby: Cassino Ao Vivo",
  filterByCategories: "Filtrar por Categoria Customizada",
  filterByGameProviders: "Filtrar por Provedores",
  filterByLobby: "Filtrar por Lobby",
  noCategory: "Nenhuma categoria",
  others: "outros",
  outras: "outras",
  image: "Imagem",
  gamesProviders: "Provedores de Jogos",
  categoryNameLabel: "Nome da Categoria",
  areYouSureToDelete: "Tem certeza que deseja excluir a categoria?",
  deletingCategoryAlert:
    "A ação a seguir vai excluir a categoria de jogos existente e os jogos configurados para aparecer nesta categoria perderão este status. Você pode configurá-los para serem exibidos em outras categorias.",
  customCategory: "Categoria customizada",
  standardCategory: "Padrão",
  casinoType: "Tipo de Cassino",
  createCategory: "Criar Categoria",
  editCategory: "Editar Categoria",
  deleteCategory: "Excluir Categoria",
  ativa: "Ativa",
  inativa: "Inativa",
  weight: "Peso",
  categories: "Categorias",
  games: "Jogos",

  noDataOptions: "Nenhuma opção disponível",
  noDataTablePlayers: "Sem jogadores para listar",
  filterBy: "Filtrar Por",
  dataByRegion: "Dados por Região",
  qtdPlayers: "Qtd. de Jogadores",
  homeGraphicTitle: {
    overviewDescription:
      "Transações com saldo online de Apostas Esportivas e Cassino.",
    sports: "Apostas Esportivas",
    casino: "Apostas de Cassino",
    offensivePlayers: "Jogadores Contra a Casa",
    noOffensivePlayers: "Jogadores a Favor da Casa",
    averageDailyDescription:
      "Ticket Médio: {average} | Prêmios Médio: {average} | Média Diária: {average}",
  },
  homeChartLineOptions: {
    sports: {
      title: "Apostas Esportivas - Gráfico",
      // verticalLabel: "R$",
      horizontalLabel: "Dia/Mês",
    },
    casino: {
      title: "Apostas de Cassino - Gráfico",
      // verticalLabel: "R$",
      horizontalLabel: "Dia/Mês",
    },
  },
  listAndExportTokensTip: "Listar / Exportar Tokens",

  redeemedTokens: "Tokens Resgatados",
  dateUse: "Data de Ativação",
  quantityOfTokensAsterisk: "Quantidade de Tokens *",
  quantityOfTokens: "Quantidade de Tokens",
  notRansomed: "Não resgatados",
  ransomed: "Resgatados",
  exportTokens: "Exportar Tokens",
  token: "Token",
  usersActivesByAffiliateRemainingTooltip:
    "Mínimo de usuários ativos atingido | Falta 1 usuário ativo | Faltam {remainingUsers} usuários ativos",
  usersActivesByAffiliateExplanation:
    "Para ter comissionamento precisa atingir o mínimo de usuários ativos",
  qtyUsersActives: "Qtd. Usuários Ativos",
  usersActivesByAffiliate: "Usuários ativos / mínimo",
  minActiveUsers: "Mínimo de Usuários Ativos",
  differentAspectRatio: "A imagem está numa proporção diferente da esperada",
  exportAdhesions: "Exportar adesões",
  claimExport: "Exportar reivindicações",
  exportTransfers: "Exportar transferências",
  minutes: "minuto | minuto | minutos",
  errorMessageOfToUntil:
    "O valor de 'De:' não pode ser menor ou igual que o valor 'Até:' anterior.",
  hour: "hora",
  hourCapitalized: "Hora",
  balanceType: "Tipo de Saldo",
  fixedRate: "Taxa Fixa",
  TypeBet: "Tipos de Apostas",
  realBalance: "Saldo Real",
  toManyTryLogin:
    "Seu dispositivo teve acesso bloqueado por {timeLeft} devido a várias tentativas de login.",
  defaultFeeError: "A taxa vai de 0 à 99. Use números inteiros",
  defaultFeeTooltip:
    "A taxa padrão é uma taxa de serviços que será aplicada sobre o GGR do afiliado. Você pode alterar esta taxa individualmente, ao cadastrar um novo afiliado, desmarcando a opção 'Aplicar Taxa Padrão'",
  defaultFee: "Taxa Padrão",
  commissionLive: "Ao Vivo",
  commissionPrematch: "Préjogo",
  defaultFeeSettingsAndVariableCommissions: "Configurações de Afiliados",
  updateAffiliateVariableCommission:
    "Atualizar Comissão Variável dos Afiliados",
  updateAffiliateCommissionType: "Atualizar Tipo de Comissão do Afiliado",
  updateFixedAffiliateCommission: "Atualizar Comissão Fixa do Afiliado",
  updateAffiliateFee: "Atualizar Taxa do Afiliado",
  requestedByCustumer: "Cancelamento solicitado pelo jogador",
  reason2: "Chave pix incorreta, ajuste-a e solicite novamente",
  reason3: "Ações do jogador violam nossas políticas",
  cancelWithdrawByOperator: "Saque Cancelado pelo Operador",
  // reasonCancelWithdrawLabel: "Informe o motivo",
  cancelWithdraw: "Cancelar Saque",
  adviseCancelWithdraw: "Um SMS será disparado para o jogador com o motivo:",
  feeValue: "Valor da Taxa",
  feeValueCommission: "Valor da Comissão",
  prizesCasino: "Prêmios Cassino",
  betCasino: "Apostas Cassino",
  betCasinoQty: "Qtd. Apostas Cassino",
  prizeCasinoQty: "Qtd. Prêmios Cassino",
  betsPrizeQty: "Qtd. Prêmios",
  activePlayers: "Jogadores Afiliados",
  analyticReport: "Relatório Analítico",
  draggableHint:
    "Você pode mudar a ordem de exibição dos banners arrastando as imagens para a posição desejada!",
  urlNo: "Insira uma url válida.",
  addPromotionUser: {
    title: "Vincular promoção a um usuário",
    selectDeposit: "Selecionar depósito",
    infoUser:
      "Esse usuário está vinculado a promoção '{titlePromo}'. Caso confirme a vinculação, ele perderá o progresso atual de rollover e se alguma aposta relacionada a promoção anterior estiver pendente, ela não será mais válida.",
    error: {
      selectPlayer: "Selecione um jogador",
      noDeposits: "Usuário sem depósitos",
      selectDeposit: "Selecione um depósito",
    },
    success: "Promoção adicionada ao usuário",
  },
  removeCasinoGamesByAdm: "Remover Jogos do Cassino",
  insertCasinoGamesAdm: "Inserir Jogos do Cassino",
  updateOperatorPaymentMethods: "Atualizar Métodos de Pagamento do Operador",
  seePromotion: "Ver Promoção",
  tokenTip:
    "Token é um código gerado de forma aleatória, único e exclusivo, só poderá ser ativado uma vez por um usuário apostador. Digite a quantidade de tokens que deseja criar para essa promoção. Ex.: 1000",
  bonusMax: "Bônus Máximo",
  promotionDetails: "Detalhes da Promoção",
  multMaxValueTip:
    "Determina o multiplicador máximo para apostar com o bônus vindo desta promoção. Ex.: Apostas com multiplicador total maior que 12.55 não serão permitidas com este bônus.",
  multMinValueTip:
    "Determina o multiplicador mínimo para apostar com o bônus vindo desta promoção. Ex.: Apostas com multiplicador total menor que 2.23 não serão permitidas com este bônus.",
  stakeMinValueTip1:
    "É o valor mínimo que será aceito por aposta nesta promoção. Ex.: O bônus só vai valer para apostas a partir",
  stakeMinValueTip2: "5.",
  depositMinValueTip:
    "Valor mínimo que o apostador precisa depositar para conseguir aderir à promoção.",
  bonusMaxValueTip:
    "Valor máximo que será creditado em bônus após contabilizar o percentual em cima do valor depositado.",
  prmotionTypeRegisterOrAfiliateTip:
    "Valor líquido em bônus que será creditado após cadastro a partir desta promoção.",
  promotionTypeDepositTip:
    "Percentual em cima do valor depositado que será creditado em bônus na adesão desta promoção.",
  promotionCodeTip:
    "Código que o apostador vai usar para aderir a promoção. Ex.: AFILIADOGANHA200, NOVOCADASTRO100, etc.",
  bonusTotalResgatado: "Bônus Total Resgatado",
  bonusTotalConcedido: "Bônus Total Concedido",
  promotion: "Promoção",
  startBonus: "Bônus Inicial",
  notInForce: "Não vigente",
  inForce: "Vigente",
  userExtract: "Extrato do usuário",
  adhesionTooltip: "Lista de usuários que aderiram a esta promoção",
  pleaseStandBy: "Por favor aguarde...",
  redeemed: "Resgatada",
  encerrada: "Encerrada",
  suspensa: "Suspensa",
  addOrEditFlag: "Adicionar/Editar Flag?",
  ativas: "Ativas",
  inativas: "Inativas",
  adhesionExtract: "Extrato da Adesão",
  subsequentBalance: "Saldo Posterior",
  nameOperation: "Nome da Operação",
  entryDate: "Data do lançamento",
  userStatus: "Status do Usuário",
  expiration: "Expiração",
  currentRollover: "Rollover Atual",
  totalRollover: "Rollover Total",
  idBanca: "ID Banca",
  idPromotion: "ID Promoção",
  adhesions: "Adesões",
  tooltipCpa: `Custo Por Ação<br>
  <ul>
  <li>Tipo de comissionamento: Referente a cada primeiro depósito de um jogador.</li>
  <li>Valor mínimo de depósito: Valor mínimo do primeiro depósito de cada jogador.</li>
  <li>Valor máximo de comissão: Valor máximo que seu afiliado será comissionado de acordo com o CPA definido.</li>
  </ul>`,
  commissionTypeCpa: "Tipo de Comissionamento",
  maxValueCommission: "Valor Máximo de Comissão",
  minDepositCpa: "Valor Mínimo de Depósito",
  turnover: "Turnover para Depósito",
  tooltipTurnover:
    "Para que o afiliado seja comissionado, o jogador deverá utilizar o valor depositado em apostas esportivas ou cassino.",
  adhesion: "Adesão",
  searchById: "Pesquisar por ID",
  deletedImage: "Imagem excluída!",
  noImageLoaded: "Nenhuma imagem carregada.",
  deleteImage: "Excluir",
  warningMaxSize: "A imagem ultrapassou o tamanho permitido: 1800x700",
  loadImageSuccess: "Imagem carregada com sucesso!",
  timeStart: "Hora início",
  day: "dia",
  idAffiliate: "ID Afiliado",
  loadImage: "Carregar imagem",
  acceptedFormats: "Formatos aceitos: .png, .jpg, .jpeg",
  inactivePromo: "Inativa",
  activePromo: "Ativa",
  finalizedPromo: "Finalizada",
  cancelledPromo: "Cancelada",
  expiredPromo: "Expirada",
  LabelMaximumBonusAmount: "Valor máximo de bônus",
  autoCompleteAffiliatePlaceHolder: "Insira um nome para a consulta *",
  addImage: "Adicionar imagem",
  maxTransference: "Transferência Máxima",
  rulesAndOperation: "Regras e funcionamento",
  rolloverDetails: "Detalhes do Rollover",
  percentageLabel: "%",
  minimumDeposit: "Depósito Mínimo",
  daysToExpire: "Dias Para Expirar *",
  daysToExpireTableHeader: "Dias para expirar",
  days: "dias",
  cashoutDetachedAuthorizedByCollab: "Saque Manual Autorizado Por Colaborador",
  cashoutDetachedAuthorizedByAdm: "Saque Manual Autorizado Por Administrador",
  detachedDepositByAdm: "Depósito Online Manual Por Administrador",
  detachedDepositByColab: "Depósito Online Manual Por Colaborador",
  customLandingPages: "Landing pages personalizadas",
  LPTitleLabel: "Título",
  errorUploadingLandingPage: "Ocorreu um erro! Tente novamente.",
  successfullyLandingPage: "Landing Page enviada com sucesso!",
  textAreaWithoutCode: "Precisamos do código-fonte para salvar a landing page!",
  landingPagePlaceHolder:
    "Cole aqui o código-fonte da sua landing page. Ou use o nosso template editável, clicando em 'Carregar Template'.",
  medias: "Mídias",
  gameName: "Nome do Jogo",
  of: "de",
  eventNumber: "Número de Eventos",
  verificationNotStarted: "Não Verificado",
  verificationSuccess: "Verificado",
  verificationInProgress: "Em Processamento",
  verificationDenied: "Verificação Negada",
  collaboratorTooltip:
    "Colaboradores são pessoas que não precisam ter acesso total ao sistema. Crie grupos de permissões e em seguida atribua-os aos Colaboradores.",
  groupsTooltip:
    "Grupos são as permissões atribuídas a um Colaborador. Elas irão permitir ou não o Colaborador a visualizar menus ou realizar ações.",
  loginAsCollaborator: "Entrar como Colaborador",
  atLeastOneOption: "Você não selecionou uma permissão!",
  emptyFields: "Existem campos não preenchidos",
  selectPermissions: "Selecione as Ações:",
  insertNewGroupName: "Insira o nome do novo grupo:",
  groupName: "Nome do grupo",
  group: "Grupo",
  managed: "Gerenciado",
  createPermissionsGroup: "Novo Grupo de Permissões",
  permissions: "Permissões",
  listPermissions: "Listar Permissões",
  updatePermissions: "Editar Permissões",
  listCollaborators: "Listar Colaboradores",
  collaborator: "Colaborador",
  collaborators: "Colaboradores",
  block: "Bloquear",
  editCollaboratorRegisterData: "Editar dados de cadastro",
  groups: "Grupos",
  editCollaborator: "Editar Colaborador",
  newCollaborator: "Novo Colaborador",
  registerCollaborator: "Registrar Colaborador",
  idUser: "ID Usuário",
  warningAboutBanks:
    "Cuidado! Ao excluir um banco, o jogador que possui uma chave pix verificada com esse banco terá que fazer o processo de verificação novamente.",
  allowedBanksConfiguration: "Configurações de Bancos",
  selectAtLeastOneBank: `Selecione pelo menos um banco ou configure a verificação bancária como "Não".`,
  languages: "Idiomas",
  termsOfUse: "Termos de Uso",
  responsibleGambling: "Jogo Responsável",
  dataProtection: "Proteção de Dados",
  aml: "AML",
  totalBetsValue: "Total Apostas",
  totalBetsAmount: "Qtd. de Apostas",
  totalValidBetsValue: "Total Válidas",
  totalValidBetsAmount: "Qtd. Válidas",
  totalRefundedBetsValue: "Total Devolvidas",
  totalRefundedBetsAmount: "Qtd. Devolvidas",
  totalPrizesValue: "Prêmios",
  totalPrizesAmount: "Qtd. de Prêmios",
  groupBy: "Agrupar por",
  document: "Documento",
  documents: "Documentos",
  betCashout: "Aposta Encerrada",
  chooseBanks: "ESCOLHER BANCOS",
  bankVerification: "Verificação Bancária",
  banks: "Bancos",
  allowedBanks: "Selecione os bancos permitidos:",
  startTypingABank: "Comece a digitar um banco",
  chooseBanksHint: `
    Se você deseja restringir bancos, selecione "Sim" e escolha os bancos que deseja permitir. (Recomendado) <br/>
    Se deseja permitir todos os bancos, pode deixar selecionado "Não".
    `,
  selectAll: "Selecionar todos",
  removeAll: "Remover todos",
  playerNameIsRequired: "Informe um ID, nome, login, telefone, email ou CPF!",
  autoCompleteNoData: "Sem dados de consulta",
  cantCalculateSurebet:
    "Não é possível calcular o lucro pois uma ou mais odds estão suspensas.",
  surebetFormula: "Cálculo estimado com base na fórmula de Surebet",
  hideEstimatedProfit: "Esconder lucro estimado",
  showEstimatedProfit: "Mostrar lucro estimado",
  selectAgent: "Selecione um agente.",
  agentBet: "Aposta Agente",
  onlineBetting: "Aposta Online",
  allBets: "Todas as Apostas",
  bonusBet: "Aposta Bônus",
  firstDeposit: "Primeiro depósito",
  finishedBet: "Encerrada",
  finishedBetPlural: "Encerradas",
  withTransactions: "Exportar por jogador que fez depósito ou saque",
  noRegister: "Não há registro",
  activation: "Ativação",
  suspension: "Suspensão",
  massAgentsUpdateTitle: "Atualização em Massa de Agentes",
  massAgentsUpdateTitleMobile: "Atualização de Agentes",
  massAgentsUpdateContent:
    "Escolha uma ação para realizar nos agentes do gerente {managerName}.",
  massAgentsSuspensionTitle: "Suspensão em Massa de Agentes",
  massAgentsSuspensionTitleMobile: "Suspensão de Agentes",
  massAgentsSuspensionContent:
    "Todos os agentes do gerente serão suspensos. Tem certeza que deseja continuar?",
  massAgentsActivationTitle: "Ativação em Massa de Agentes",
  massAgentsActivationTitleMobile: "Ativação de Agentes",
  massAgentsActivationContent:
    "Todos os agentes do gerente serão ativados. Tem certeza que deseja continuar?",
  bonusConsumed: "Bônus Consumido",
  groupCreated: "Grupo Criado",
  groupUpdated: "Grupo Atualizado",
  promotionInserted: "Promoção Inserida",
  promotionDeleted: "Promoção Deletada",
  changingStatusOfSelfSuspendedPlayer:
    "Não é possível mudar o status de um jogador autossuspenso.",
  suspendedSince: "Suspenso desde: ",
  selfSuspended: "Autossuspenso",
  limitSuspensionDate: "Suspenso até",
  playerSuspended: "Suspensão de Jogador",
  doubleAccount: "Mais de Uma Conta",
  suspiciousBehavior: "Comportamento Suspeito",
  textAreaPlaceholderSuspension:
    "Insira um breve motivo para a suspensão do usuário.",
  textAreaPlaceholderDisable:
    "Insira um breve motivo para a desabilitação do usuário.",
  suspensionReason: "Motivo",
  disableReason: "Motivo da Desabilitação",
  warningDisable:
    "Esta ação só poderá ser desfeita abrindo um ticket com o suporte.",
  bugAbuse: "Abuso de Falhas no Sistema",
  outdatedInformation: "Informações Desatualizadas",
  termsAndConditionsViolation: "Violação dos Termos e Condições",
  financialProtection: "Proteção Financeira",
  other: "Outro",
  selectAReasonToSuspend: "Selecione uma razão para suspensão do usuário",
  selectAReasonToDisable: "Selecione uma razão para desabilitação do usuário",
  depositBalance: "Saldo Depósito",
  loginButton: "Entrar",
  editAgentBalance: "Editar o Saldo do Agente",
  agentBalance: "Saldo do Agente",
  incrementAgentBalance: "Adição ao Saldo do Agente",
  totalOnlineBalanceDescription: "Saldo total de usuários online",
  onlineBalance: "Saldo Online",
  bonusBalance: "Saldo Bônus",
  totalOnlineBalance: "Saldo",
  paymentMethods: "Meios de Pagamento",
  copyCode: "Copiar código",
  depositForPlayerPixDescription:
    "Você está realizando um depósito para um jogador. O método de pagamento é PIX, e o valor de R$ {value} será creditado na conta do jogador alguns segundos depois que o pagamento for confirmado.",
  depositForPlayerManualDescription:
    "Você está realizando um depósito manual para um jogador. Será creditado na conta do jogador o valor de R$ {value}.",
  depositForPlayer: "Depositar",
  login: "Acesso",
  betsWithDeposit: "Apostas com Saldo Depósito",
  betsWithBonus: "Apostas com Saldo Bônus",
  depositForPlayerPayment: "Pagamento do depósito",
  portuguese: "Português",
  spanish: "Espanhol",
  english: "Inglês",
  hiWelcome: "Olá, seja bem-vindo!",
  navigateSideMenu: "Navegue pelo menu lateral.",
  print: "Imprimir",
  paidBets: "Pagar apostas",
  paidBet: "Pagar Aposta",
  wantPaidBet: "Você quer pagar a aposta",
  search: "Pesquisar",
  live: "Ao vivo",
  resumeSummary: "Resumo do período",
  value: "Valor",
  prizePaids: "Prêmios pagos",
  prizePossibles: "Prêmios possíveis",
  prizeTotal: "Prêmios totais",
  code: "Código",
  info: "Informações",
  events: "Eventos",
  dateHour: "Data/Hora",
  return: "Retorno",
  result: "Resultado",
  action: "Ação",
  activeAgents: "Agentes ativos",
  weeklyChart: "Gráfico semanal",
  grossAndPremium: "Bruto vs Prêmio",
  from: "De",
  areas: "Áreas",
  until: "Até",
  monday: "Segunda-feira",
  tuesday: "Terça-feira",
  wednesday: "Quarta-feira",
  thursday: "Quinta-feira",
  friday: "Sexta-feira",
  saturday: "Sábado",
  sunday: "Domingo",
  gross: "Bruto",
  labelCurrency: "R$",
  awards: "Prêmios",
  informations: "Informações",
  dateTime: "Data/Hora",
  paid: "Pago",
  actions: "Ações",
  canceledList: "Lista de cancelados",
  deferredList: "Lista de adiados",
  view: "Visualizar",
  periodSummary: "Resumo do Período",
  paidPremiuns: "Prêmios Pagos",
  passibleAwards: "Prêmios Possíveis",
  totalPrizes: "Prêmios totais",
  cancelledIn: "Cancelada em",
  amount: "Qtd.",
  player: "Jogador",
  sellerCode: "Cód. Vendedor",
  operation: "Operação",
  commission: "Comissão",
  status: "Status",
  cancelCredit: "Cancelar Crédito",
  msgConfirmCancelCredit: "Deseja realmente cancelar o crédito de",
  consultedBy: "Consultado por",
  dayAndTimeOfPrinting: "Dia e horário da impressão",
  newRegionalManager: "Novo Gerente Regional",
  name: "Nome",
  createdIn: "Criado em",
  edit: "Editar",
  registrationForm: "Ficha Cadastral",
  applyDefaultFee: "Aplicar taxa padrão",
  fullName: "Nome Completo",
  settings: "Configurações",
  profitCommission: "Comissão sobre o lucro",
  areaOfExpertise: "Área de Atuação",
  regionalCreditforAgents:
    "Este Regional pode administrar crédito para os Agentes?",
  regionalLimitsforAgents:
    "Este Regional pode administrar os limites dos Agentes?",
  credentials: "Credenciais",
  changePassword: "Alterar senha",
  password: "Senha",
  confirmPassword: "Confirmar Senha",
  toSave: "Salvar",
  yes: "Sim",
  no: "Não",
  thisFieldIsRequired: "Este campo é obrigatório.",
  repeatPassword: "Repita a senha",
  activate: "Ativar",
  pending: "Pendente",
  supend: "Suspender",
  disable: "Desativar",
  newLocalManager: "Novo Gerente Local",
  profile: "Perfil",
  regionalManager: "Gerente Regional",
  localCreditforAgents: "Este Local pode administrar crédito para os Agentes?",
  localLimitsforAgents: "Este Local pode administrar os limites dos Agentes?",
  localAdminPaidBets: "Este Local pode administrar os pagamentos das apostas?",
  newAgent: "Novo Agente",
  commissions: "Comissões",
  viewBets: "Visualizar Apostas",
  mLocal: "G. Local",
  mRegional: "G. Regional",
  subordination: "Subordinação",
  mobile1: "Celular 1",
  mobile2: "Celular 2",
  address: "Endereço",
  toSaveStateMsg:
    "Para salvar um Estado e Cidade, é necessário inserir um CEP válido.",
  state: "Estado",
  limits: "Limites",
  valuePerMatch: "Valor por Partida (em aposta Simples)",
  dailyBettingLimit: "Limite Diário de Apostas",
  dailyLimitSingleBets: "Limite Diário para Apostas Simples",
  dailyLimitDoubleBets: "Limite Diário para Apostas Duplas",
  maximumAgentAward: "Prêmio Máximo do Agente",
  creditSaleLimit: "Limite Venda de Crédito",
  generalSalesLimit: "Limite de Vendas Geral",
  generalSalesLimitIncrement: "Adição ao Limite de Vendas Geral",
  reset: "Zerar",
  activateLive: "Ativar Ao vivo",
  vieAwardees: "Visualizar premiadas",
  automaticPayment: "Pagamento automatico?",
  marginOfQuotation: "Margem da Cotação",
  commissionsOnCreditSales: "Comissão sobre vendas de crédito",
  maximumMutiplier: "Mult. Máx de aposta",
  minimumMultiplier: "Mult. Min. de aposta",
  active: "Ativo",
  blocked: "Bloqueado",
  phoneMustCointais11Digits: "Telefone deve conter 11 digitos",
  CPFMustCointais11Digits: "CPF deve conter 11 digitos",
  city: "Cidade",
  remarks: "Observações",
  newCollector: "Novo arrecadador",
  routesToCollect: "Rotas a coletar",
  closings: "Fechamentos",
  regionalIdManager: "ID Ger. Regional",
  collector: "Arrecadador",
  agent: "Agente",
  route: "Rota",
  payCollect: "Pagar/Coletar",
  noRouteToCollect: "Nenhuma rota a coletar",
  summary: "Resumo",
  payable: "A pagar",
  toCollect: "A coletar",
  total: "Total",
  newRoute: "Nova Rota",
  nameCollector: "Nome Arrecadador",
  routeName: "Nome da Rota",
  linkRegional: "Vincular Regional",
  selectRegional: "Selecione regional",
  linkAgents: "Vincular Agentes",
  selectAgents: "Selecione Agentes",
  previous: "Anterior",
  users: "Usuários",
  page: "Página",
  next: "Próxima",
  dtRegistration: "Data de Cadastro",
  cellPhone: "Celular",
  downloadPt: "Baixar",
  download: "Download",
  actives: "Ativos",
  inactives: "Inativos",
  inactivesPlayersMsg:
    " * Inativos: Jogadores que não realizaram login nos últimos 30 dias ou nunca logaram.",
  noDataForthisQuery: "Não há dados para esta consulta.",
  canPlaceBetsOnline: "Pode fazer apostas online",
  balance: "Saldo",
  factor: "Fator",
  bets: "Apostas",
  validBets: "Apostas válidas",
  exemptBets: "Apostas isentas",
  credit: "Crédito",
  userUnconfirmedAccontMsg:
    "Este usuário consta com sua conta não confirmada. Você pode reenviar o link de confirmação.",
  resentSMS: "Reenviar SMS",
  resentEmail: "Reenviar E-mail",
  awardRedemption: "Resgate de Premiação",
  whichAgentIdCanRequest:
    "Aqui você pode definir qual id de agente o usuário (jogador) pode solicitar resgate de seus prêmios.",
  whichAgentIdCanRequestAffiliate:
    "Aqui você pode definir qual id de agente o usuário (jogador) pode ser afiliado.",
  searchAgent: "Pesquisar um agente",
  defineTheAgent: "Definir o agente (informe apenas o Id do Agente)",
  userLimits: "Limites do usuário",
  realiabilityFactor: "Fator de Confiabilidade",
  newArea: "Nova Área",
  subAreaOf: "Sub área de",
  promotionDescription: "Descrição *",
  description: "Descrição",
  areaName: "Nome da Área",
  areaDescroption: "Descrição da Área",
  grouped: "Agrupado",
  list: "Lista",
  qtyBet: "Qtd. Aposta",
  qtyBets: "Qtd. Apostas",
  salesBets: "Vendas Apostas",
  cancelledBets: "Apostas Canceladas",
  coAgentBet: "Co. Agente (Aposta)",
  coAffiliateBet: "Co. Afiliado (Aposta)",
  qtyCredits: "Qtd. Créditos",
  salesCredits: "Vendas Créditos",
  coAgentCredit: "Co. Agente (Crédito)",
  coGerLocal: "Co. Ger. Local",
  grossProfit: "Lucro bruto",
  coRegionalManager: "Co. Ger. Regional",
  netProfit: "Lucro líquido",
  qtyAgents: "Qtd. Agentes",
  qtyAffiliates: "Qtd. Afiliados",
  credits: "Créditos",
  coAgentCreditSales: "Co. Agente (Venda de Créditos)",
  coRegionalCreditSales: "Co. Regional (Venda de Créditos)",
  agentName: "Nome do Agente",
  numbersOfAgents: "Quantidade de Agentes",
  numberOfAffiliates: "Quantidade de Afiliados",
  commissionRegionalOnGrossProfit:
    "Comissão do Gerente Regional sobre o lucro bruto.",
  amountBetsSold: "Quantidade de apostas vendidas",
  bettingSalesValue: "Valor de vendas de Apostas",
  reverseOfCanceledBets: "Estorno de apostas canceladas",
  agentsCommissiononBettingSales:
    "Comissão do agente sobre as vendas de apostas",
  amountOFCreditsSold: "Quantidade de créditos vendidos",
  creditSalesAmount: "Valor de vendas de créditos",
  agentCommissionInfoKey: "Comissão do agente sobre a venda de créditos",
  localManagerCommissionInfoKey:
    "Comissão do gerente local sobre as vendas de agentes",
  awardValue: "Valor de premiações",
  netProfitResume:
    "Lucro Líquido é o lucro bruto menos a comissão de gerente regional",
  groosProfitResume:
    "Lucro bruto é o total das vendas menos as comissões e prêmios",
  launch: "Lançamento",
  previousBalance: "Saldo Anterior",
  gerLocal: "Ger Local",
  qty: "Qtd.",
  sales: "Vendas",
  balanceReport: "Balanço",
  totalBalance: "Balanço Total",
  extract: "Extrato",
  extractAgent: "Extrato Agente",
  filter: "Filtro",
  date: "Data",
  salesQty: "Qtd. Vendas",
  verified: "Apurado",
  canceled: "Cancelado",
  rights: "Acertos",
  dayBalance: "Saldo Dia",
  finalBalance: "Saldo Final",
  noDrivesFount: "Nenhuma movimentação encontrada.",
  filterFrom: "Filtro de",
  category: "Categoria",
  lastPickup: "Último Recolhimento",
  depostiForPaymentOfPremiums: "Depósito para pagamento de prêmio(s)",
  miscellaneoutDeposit: "Depósito diversos",
  reverse: "Estorno",
  for: "Para",
  receiveFromTheAgent: "Receber do Agente",
  payTheAgent: "Pagar ao Agente",
  launchedBy: "Lançado Por",
  receivedPaid: "Recebido/Pago",
  received: "Recebido",
  paids: "Pagos",
  TOTAL: "TOTAL",
  releases: "Lançamentos",
  region: "Região",
  area: "Área",
  amountBet: "Qtd. Aposta",
  betCanceled: "A. Canceladas",
  regionalCo: "Co. Regional",
  coAgentSalesBets: "Co. Agente (Venda de Apostas)",
  graphic: "Gráfico",
  news: "Novos",
  olds: "Antigos",
  championship: "Campeonato",
  match: "Partida",
  nOfBets: "Nº Apostas",
  simple: "Simples",
  multiples: "Multiplas",
  lost: "Perdido",
  add: "Adicionar",
  combinationAnalysis: "Analíse da Combinação",
  exactly: "Exato",
  combination: "Combinação",
  simulationOnProvider: "Simulação no Provedor",
  betAmount: "Valor apostado",
  possibleReturn: "Retorno possível",
  totalCommission: "Total de comissão",
  betting: "Apostando",
  youtReturnWouldBe: "Seu retorno seria",
  countryLeague: "País/Liga",
  league: "Liga",
  event: "Evento",
  odd: "Cotação",
  filters: "Filtros",
  toFilter: "Filtrar",
  country: "País",
  tournament: "Torneio",
  cancelled: "Cancelados",
  postponed: "Adiados",
  suspended: "Suspendidos",
  thisEventCannotBeCanceled: "Este evento não pode ser cancelado!",
  thisEventCannotBeSuspended: "Este evento não pode ser suspenso!",
  all: "Todos",
  allowedFieldUpTo100: "Campo permitido até 100%",
  toSelect: "Selecione",
  institutional: "Institucional",
  workWithusAndContact: "TRABALHE CONOSCO E CONTATO",
  publicContactEmail: "E-mail de contato com o público:",
  socialNetWorks: "REDES SOCIAIS (OPCIONAIS)",
  aboutYourCompany: "SOBRE SUA EMPRESA",
  tellAboutYourBusiness: "Informe ao seu público um pouco SOBRE seu negócio:",
  registrationDataBilling: "Dados Cadastrais / Faturamento",
  dataResponsible: "DADOS RESPONSÁVEL",
  dataAddress: "DADOS DE ENDEREÇO",
  number: "Número",
  neighborhood: "Bairro",
  generalSettings: "Configurações Gerais",
  promotions: "Promoções",
  informPromotionsByYourBusiness:
    "Informe ao seu público promoções promovidas pela seu negócio:",
  toCancel: "Cancelar",
  generalSettingsAgents: "Configurações Gerais - Agentes",
  cancellationOfBetByAgent: "CANCELAMENTO DE APOSTA PELO AGENTE",
  cancelBet: "Cancelar aposta",
  minutesToCancel: "Minutos para cancelamento",
  generalSettingsPortal: "Configurações Gerais - Portal",
  portalOptions: "OPÇÕES DO PORTAL",
  acceptPreBet: "Aceitar pré-aposta?",
  activateLiveModule: "Ativar módulo ao vivo?",
  minutesAllowrdOnLive: "Minutos permitido no Ao Vivo",
  generalSettingsBanking: "Configurações Gerais - Banca",
  controlOfLimits: "CONTROLE DE LIMITES",
  numbersOfDaysInTable: "Números de dias na tabela",
  maximumEventsPerBet: "Máximo de eventos por aposta",
  maximumBankingAward: "Prêmio máximo da banca",
  minimumBetAmount: "Valor mínimo de uma aposta",
  maximumValueOfBet: "Valor máximo de uma aposta",
  minimumMultiplierForABet: "Multiplicador mínimo para uma aposta",
  maximumMultiplierForABet: "Multiplicador máximo para uma aposta",
  doNotDisplayQuotesBelow: "Não exibir na tabela cotações abaixo de",
  maximumLimitByOptionOnEvent: "Limite máximo por opção no evento",
  maximumLimitByMarketOnEvent: "Limite máximo por mercado no evento",
  percentUserCanHighLimit: "Porcent. que o usuário pode usar do limite máximo",
  PRINT: "IMPRESSÃO",
  observation: "Observação",
  reulationForThePortal: "REGULAMENTO PARA O PORTAL",
  filterByCountry: "Filtrar por um país",
  selectASport: "Selecione um esporte",
  noDataFount: "Nenhum dado encontrado!",
  selectAMarket: "Selecione um mercado",
  preGame: "Pré Jogo",
  Live: "Ao Vivo",
  oddMax: "Odd Máx",
  recommendedImagiSizeBanner:
    "Proporções recomendadas para a imagem do banner são: 3:1 (ex.: 900x300px, 1200x400px) até 5:2 (ex.: 1500 x 600px, 1000 x 400px), nos formatos de arquivo .png ou .jpg com máx. de 2MB. Ao fazer upload das imagens, procure sempre enviar imagens na mesma proporção.",
  recommendedImagiSizeParner:
    "Tamanho de imagem recomendado para Parceiros, Licença, M. de Pagamentos 100x100 pixels (.png, .jpg ou .gif) com máx. de 1Mb.",
  recommendedImagiSizePopup:
    "Tamanho de imagem recomendado para Pop-up 512x512 pixels (.png, .jpg ou .gif) com máx. de 1Mb.",
  recommendedImagiSizePromoImage:
    "Tamanho de imagem recomendado 1800x700 pixels (.png ou .jpg) com máx. de 1Mb.",
  recommendedImagiSizeMenu:
    "Tamanho de imagem recomendado para Menu 300px largura com altura relativa (.png, .jpg ou .gif) com máx. de 1Mb.",
  selectABanner: "Selecione um banner:",
  addBanner: "Adicionar Banner",
  errorDeletingImage: "Ocorreu um erro ao excluir sua imagem: ",
  chooseAnImageFirst: "Por favor, escolha uma imagem primeiro.",
  imageTooLarge: "Imagem muito grande (2MB no máximo).",
  fileTypeNotAllowed:
    "Tipo de arquivo não permitido! Apenas permitido .png, .jpg. ou .gif",
  fileTypeNotAllowedImage:
    "Tipo de arquivo não permitido! Apenas permitido .png ou .jpg.",
  maximum6Images: "Máximo 6 imagens.",
  bannerSentsuccessfully: "Banner enviado com sucesso.",
  errorUploadingBanner: "Ocorreu um erro ao enviar seu banner: ",
  banners: "Banners",
  partners: "Parceiros",
  license: "Licença",
  toView: "Visualizar",
  sgaNotifications: "Notificações SGA",
  yourNotifications: "Suas Notificações",
  subject: "Assunto",
  noSubject: "Sem assunto",
  read: "Lido",
  notRead: "Não lido",
  toActive: "Ativar",
  toDisable: "Desativar",
  toSend: "Enviar",
  openInvoice: "Abrir Fatura",
  payment: "Pagamento",
  dueDate: "Vencimento",
  interest: "Juros",
  pay: "Pagar",
  seccondCopy: "Segunda via",
  ticket: "boleto",
  period: "Período",
  plan: "Plano",
  amountTotal: "Valor Total",
  errorGeneratingDuplicate: "Erro ao gerar segunda via",
  enterYourCurrentPassword: "Informe sua senha atual",
  currentPassword: "Senha atual",
  enterANewPassword: "Informe uma nova senha",
  newPassword: "Nova Senha",
  enterPasswordHinit:
    "Informe uma senha com 8 caracteres contendo letras e números.",
  inputRequired: "Este campo é obrigatório.",
  generalSettingsTransactions: "Configurações Gerais - Transações",
  minimumDepositAmount: "Mínimo valor de depósito",
  depositFee: "Taxa de depósito",
  maximumWithdrawalValue: "Máximo valor de saque",
  minimumWithdrawalAmount: "Mínimo valor de saque",
  withdrawalRate: "Taxa de saque",
  minBonusBetMultiplier: "Multiplicador min. de aposta bônus",
  minMetaBonusMultiplier: "Multiplicador min. meta bônus",
  percentageOfBonus: "Percentual de Bônus *",
  maximumBonusAmount: "Valor máximo do bônus",
  solicitedBonus: "Bônus Solicitados",
  cosolidatedBonus: "Bônus Consolidados",
  cancelledBonus: "Bônus Cancelados",
  bonusID: "ID Bônus",
  requisted: "Solicitado",
  registered: "Registrado",
  consolidated: "Consolidado",
  didCancelled: "Cancelado",
  deposits: "Depósitos",
  withdrawals: "Saques",
  user: "Usuário",
  amountOfDeposits: "Qtd. Depósitos",
  amountOfWithdrawals: "Qtd. Saques",
  authorized: "Autorizado",
  depositID: "ID Depósito",
  deposit: "Depósito",
  withdrawalID: "ID Saque",
  authorization: "Autorização",
  phone: "Telefone",
  randomKey: "Chave aleatória",
  consolidatedValue: "Valor Consolidado",
  authorizePayment: "Autorizar Pagamento",
  userID: "ID do Usuário",
  toConfirm: "Confirmar",
  confirmWithdrawalAuthorization: "Confirmar autorização de saque?",
  authorizeWithdrawal: "Autorizar Saque",
  revenues: "Faturamento",
  commissionRegionalOnGrossGGR: "Comissão do Gerente Regional sobre o GGR.",
  valueOnSoldBets: "Valor em apostas vendidas",
  valueInAwards: "Valor em premiações",
  ggrExplanation: "GGR é o valor do faturamento subtraindo o valor de prêmios.",
  feeGGRPercentageExplanation: "Taxa de serviços aplicada sobre o GGR.",
  valueNGRExplanation: "Líquido após aplicação de taxas de serviços.",
  agentCommissionExplanation: "Comissão do agente sobre o GGR",
  affiliateCommissionExplanation: "Comissão do afiliado sobre o GGR",
  localCommissionExplanation: "Comissão do gerente local sobre o GGR",
  valuesFinancial: "Valores Financeiros",
  awarded: "Premiadas",
  quantities: "Quantidades",
  AmountLostBets: "Qtd. Perdidas",
  amountAwarded: "Qtd. Premiadas",
  pendings: "Pendentes",
  amountPending: "Qtd. Pendentes",
  betsAmount: "Qtd. Apostas",
  maximumInstantWithdrawalValue: "Valor máximo de saque instantâneo",
  minimunDepoistAmount: "Valor mínimo de depósito.",
  minimumMultiplierToGoalBonus:
    "Multiplicador mínimo para atingir a meta e resgatar o Bônus",
  percentageOnDeposit: "Percentual sobre depósitos.",
  maximumValueOfWithdrawal: "Valor máximo de um saque.",
  minimumValueOfWithdrawal: "Valor mínimo de um saque.",
  percentageOnWithdrawals: "Percentual sobre saques.",
  percentageOfBonusOperator: "Percentual do bônus definido pela banca.",
  limitMaximumAmountBonus: "Limite o valor máximo para bônus.",
  minimulMultiplerForBettingBonus:
    "Multiplicador Mínimo para aposta com Saldo Bônus",
  maximumValueUserWithdrawInstantly:
    "Valor máximo que um usuário pode sacar instantaneamente",
  affiliates: "Afiliados",
  affiliate: "Afiliado",
  nameAffiliate: "Nome Afliado",
  searchAffiliateSpan: "Pesquise por ID, nome, login ou E-mail do seu afiliado",

  findAnAffiliate: "Buscar um afiliado",
  singleAffiliate: "Afiliado único",
  players: "Jogadores",
  depositsAndWithdrawals: "Depósitos e Saques",
  promotionLabelBonus: "Bônus *",
  bonus: "Bônus",
  configuration: "Configuração",
  configurationOnline: "Configuração ",
  accountability: "Prest. de Contas",
  account: "Conta",
  reports: "Relatórios",
  system: "Sistema",
  listBets: "Listar Apostas",
  listCredits: "Listar Créditos",
  playersList: "Jogadores Lista",
  inactivePlayers: "Jogadores Inativos",
  extractByUser: "Extrato por Usuário",
  betsPDV: "Apostas PDV",
  historic: "Histórico",
  regionalManagers: "Gerentes Regionais",
  editRegionalManager: "Editar Gerente Regional",
  localManagers: "Gerentes Locais",
  editLocalManager: "Editar Gerente Local",
  editAgent: "Editar Agente",
  agentBettingCommision: "Comissões - Faixa De Eventos",
  collectors: "Arrecadadores",
  editCollector: "Editar Arrecadador",
  routes: "Rotas",
  editRoute: "Editar Rota",
  listAreas: "Listar Áreas",
  editArea: "Editar Área",
  eventsBetting: "Apostas eventos",
  defense: "Defesa",
  generalFinding: "Apuração Geral",
  areaFinding: "Apuração Área",
  routesFinding: "Apuração Rotas",
  agentRelease: "Lançamento Agente",
  balanceByRoute: "Balanço por Rota",
  editOdd: "Editar Odd",
  bankConfiguration: "Configuração banca",
  manageLeagues: "Gerenciar Ligas",
  marketsAndMargins: "Mercados e Margens",
  manageMedia: "Gerenciar Mídias",
  notifications: "Notificações",
  notification: "Notificação",
  invoices: "Faturas",
  invoice: "Fatura",
  agents: "Agentes",
  historyLocalBettingManager: "Histórico Apostas Gerente Local",
  balancePerRoute: "Balanço por rota",
  cashCollector: "Caixa Arrecadador",
  newRelease: "Novo lançamento",
  collectorReport: "Relatório Arrecadador",
  agentCreditHistory: "Histórico Crédito Agente",
  agentsList: "Lista de Agentes",
  enterCurrentPassword: "Informe sua senha atual",
  labelCurrentPassword: "Senha atual",
  labelNewPassword: "Nova Senha",
  hintNewPassword:
    "Informe uma senha com 8 caracteres contendo letras e números.",
  confirmNewPassword: "Confirmar nova senha",
  btnChangePassword: "Alterar senha",
  rulesPassMatch: "Este campo é obrigatório.",
  rulesRepeatPassword: "Repita a senha",
  labelLogin: "Login",
  printDate: "Dia e horário da impressão:",
  btnPrint: "Imprimir",
  labelSearch: "Pesquisar",
  itemsPerPage: "Linhas por página",
  justResume: "Resumo",
  localManagerId: "ID Ger. Local",
  localManagerName: "Ger. Local",
  agentId: "ID Agente",
  headersAgentName: "Agente",
  grossValue: "Faturamento",
  prizeValue: "Prêmios",
  valueGGR: "GGR",
  valueGGRProjected: "Receita (Saldo Online)",
  agentCommission: "Com. Agente",
  affiliateCommission: "Com. Afiliado",
  localManagerCommission: "Com. Ger. Local",
  regionalManagerCommission: "Com. Ger. Regional",
  qtdAgents: "Qtd. Agentes",
  qtdBets: "Qtd. Apostas",
  infoAgentName: "Nome do Agente",
  infoAffiliateName: "Nome do Afiliado",
  infoQtdAgent: "Quantidade de Agentes",
  infoGrossValue: "Valor em apostas vendidas",
  infoPrizeValue: "Valor em premiações",
  infoValueGGR: "GGR é o valor do faturamento subtraindo o valor de prêmios",
  infoAgentCommission: "Comissão do agente sobre o GGR",
  infoLocalCommission: "Comissão do gerente local sobre o GGR",
  infoRegionalCommission: "Comissão do gerente Regional sobre o GGR",
  editedEvent: "Evento Editado",
  valorSome: "Valor_some",
  idLabel: "ID",
  infosLabel: "Informações",
  eventsLabel: "Eventos",
  dateLabel: "Data/Hora",
  valueLabel: "Valor",
  returnLabel: "Retorno",
  resultLabel: "Resultado",
  paidLabel: "Pago",
  actionsLabel: "Ações",
  paidPrizes: "Prêmios Pagos",
  possiblePrizes: "Prêmios possíveis",
  extractLabel: "Extrato",
  collectorExtract: "Extrato do Arrecadador",
  collectorLabel: "Arrecadador",
  codeLabel: "Código",
  categoryLabel: "Categoria",
  statusLabel: "Status",
  remainingBalance: "Saldo Remanescente",
  agentStatement: "Extrato Agente",
  totalReceivedFromManager: "Total recebido do Gerente",
  totalPaidToAgent: "Total pago ao(s) Agente(s)",
  totalReceivedFromAgent: "Total recebido do(s) Agente(s)",
  finalBalanceLabel: "Saldo Final",
  consolidateAndRegisterInCash: "Consolidar e registrar no caixa",
  regionalFinancialBox: "Caixa Regional",
  pediodAfterLastCollection: "Período após o último recolhimento",
  newLaunch: "Novo Lançamento",
  receivedLabel: "Recebeu",
  paidLabelCollector: "Pagou",
  notConsolidated: "Não Consolidado",
  isConsolidated: "Consolidado",
  prizeDepositPayment: "Depósito para pagamento de prêmio(s)",
  miscellaneousDeposit: "Depósitos diversos",
  chargeback: "Estorno",
  filterByDate: "Filtrar por Data",
  commissionSales: "Comissão",
  cancellations: "Cancelamentos",
  canceledBets: "Apostas Canceladas",
  deals: "Acertos",
  countSales: "Total de Vendas",
  qtdLabel: "Qtd.",
  releaseLabel: "Lançamento",
  releasesLabel: "Lançamentos",
  releasesPaid: "Pagos",
  releaseReceived: "Recebidos",
  totalLabel: "Total",
  releasedBy: "Lançado por",
  btnFilter: "Filtrar",
  agentLabel: "Agente",
  periodLabel: "Período:",
  dailyBalance: "Balanço Diário",
  dateHeader: "Data",
  extractAgentAlert: "Nenhuma movimentação encontrada",
  to: "Para",
  balanceLabel: "Balanço",
  launchType: "Tipo",
  receiveFromAgent: "Receber do Agente",
  payToAgent: "Pagar ao Agente",
  btnSave: "Salvar",
  valueEntryRules: "Este campo é obrigatório",
  userLabel: "Usuário",
  revenueLabel: "Faturamento",
  agentsComissionsLabel: "Comissões dos Agentes",
  qtdSalesCredit: "Qtd. Vendas Créditos",
  qtdCredit: "Qtd. Créditos",
  creditSales: "Vendas de Créditos",
  salesCreditCommi: "Comissões Vendas de Créditos",
  agentBetCommission: "Com. Agente (Venda de Apostas)",
  agentCreditCommission: "Com. Agente (Venda de Créditos)",
  localManagerCommiGross: "Comissões de Gerentes Locais",
  regionalManagerCommiLiquid: "Comissão Gerente Regional (Líquido)",
  betsLabel: "Apostas",
  soldBets: "Apostas Vendidas",
  fullCollection: "Recolhimento Total",
  totalDepositPremiumPayment: "Total depósito para pagamento de prêmio",
  totalMiscellaneousDeposit: "Total depósito diverso",
  totalChargeback: "Estorno Total",
  collection: "Recolhimento",
  miscellaneouDeposit: "Depósito Diverso",
  msgFeedBackSetCash: "Descrição maior que 80 caracteres",
  accounting: "Contabilidade",
  retention: "Retenção",
  registrationDate: "Data de Cadastro",
  unlimitedLabel: "Ilimitado",
  unlimited: "ILIMITADO",
  localManagerLabel: "Gerente Local",
  fullNameLabel: "Nome Completo",
  cpfLabel: "CPF",
  emailLabel: "E-mail",
  cellphoneOneLabel: "Celular 1",
  cellphoneTwoLabel: "Celular 2",
  cepLabel: "CEP",
  addressLabel: "Endereço",
  stateLabel: "Estado",
  cityLabel: "Cidade",
  commentsLabel: "Observações",
  limitsLabel: "Limites",
  valuePerMatchSingleBet: "Valor por Partida (em aposta Simples)",
  dailyBetLimit: "Limite Diário de Apostas",
  settingsLabel: "Configurações",
  activateLiveLabel: "Ativar Ao vivo",
  viewAwardees: "Visualizar premiadas",
  accessCredential: "Credenciais de Acesso",
  passwordLabel: "Senha",
  openRegister: "Abrir Caixa",
  alertRouteCollect: "Nenhuma rota a coletar",
  toPay: "A pagar",
  routeLabel: "Rotas",
  selectRoutes: "Selecione Rotas",
  routeNameLabel: "Nome da Rota",
  schedule: "Horário",
  type: "Tipo",
  client: "Cliente",
  selection: "Seleção",
  market: "Market",
  conference: "Conferência",
  printingTime: "Horário da Impressão",
  prohibitedForUnder18: "Proibido para menores de 18 anos",
  double: "Casadas",
  triple: "Tripla",
  multiple: "Multipla",
  wantCancelTheBet: "Deseja realmente cancelar a aposta",
  betConference: "CONFERÊNCIA DE APOSTA",
  noValidForAwardReceipt: "(SEM VALIDADE PARA RECEBIMENTO DE PRÊMIO)",
  reverseAmount: "Valor estornado",
  right: "Acertou",
  refund: "Reembolso",
  missed: "Errou",
  betCod: "Aposta cod. ",
  datas: "Dados",
  noRouteLinked: "Nenhuma rota vinculada",
  noAgentLinked: "Nenhum agente vinculado",
  update: "Atualizar",
  submitBetId: "Envie o id da aposta!",
  toClose: "Fechar",
  dialogCommissionLive:
    "Caso haja ao menos um evento ao vivo na aposta, aplica-se a comissão do ao vivo.",
  localManager: "Gerente Local",
  searchPlayers: "Pesquisar Jogadores ",
  searchPlayer: "Pesquisar Jogador",
  seachPlayersMsg: "Pesquise por ID, nome, login, telefone, Email ou CPF",
  dateRange: "Intervalo de datas",
  toClean: "Limpar",
  terminal: "Terminal",
  general: "Geral",
  breaks: "Intervalos",
  today: "Hoje",
  yesterday: "Ontem",
  lastMonth: "Mês passado",
  currentWeek: "Esta semana",
  lastWeek: "Semana passada",
  lastSevenDays: "Últimos 7 dias",
  halfMonth: "Últimos 15 dias",
  currentMonth: "Mês atual ",
  invalidTime: "Horário inválido",
  weeklyCalculation: "Apuração Semanal",
  currentCalculation: "Apuração Atual",
  paidAndReceiverFromAgent: "Pagos e Recebidos do agente",
  onlyReceivedFromAgent: "Apenas 'Recebido' do agente",
  onlyPaitToTheAgent: "Apenas 'Pago' ao agente",
  losts: "Perdidas",
  didSuspended: "Suspenso",
  doActives: "Ativas",
  cancelleds: "Canceladas",
  statusEvent: "Status Evento",
  cancelledsMasc: "Cancelados",
  depositRequested: "Depósito Solicitado",
  depositConsolidated: "Depósito Consolidado",
  depositCancelled: "Depósito Cancelado",
  withdrawalRequisted: "Saque Solicitado",
  withdrawalAuthorized: "Saque Autorizado",
  withdrawalConsolidated: "Saque Consolidado",
  withdrawalCancelled: "Saque Cancelado",
  bonusCancelled: "Bônus Cancelado",
  bonusRequested: "Bônus Solicitado",
  bonusConsolidated: "Bônus Consolidado",
  byValue: "Por Valor",
  exactValue: "Valor exato:",
  valueGreaterThan: "Valor maior que:",
  valueLessThan: "Valor menor que:",
  consultBet: "Consultar Aposta",
  network: "Rede",
  weeklyCalculationReport: "Relatório Apuração Semanal",
  currenccalculationReport: "Relatório Apuração Atual",
  report: "Relatório",
  copySuccessfully: "Copiado com sucesso!",
  unexpectedErrorOccured:
    "Ocorreu um erro inesperado, tente novamente mais tarde!",
  notStarted: "Não iniciado",
  inProgress: "Em progresso",
  documentInAnalysis: "Em Análise",
  finished: "Finalizado",
  didPostponed: "Adiado",
  interrupted: "Interrompido",
  abandoned: "Abandonado",
  closeToStart: "Perto de iniciar",
  pageNotFound: "Página não encontrada",
  comeBack: "Voltar",
  _homePage: "Página Inicial",
  byUser: "Por usuário",
  readQRcodeToPayPIX:
    "Para realizar o pagamento via pix faça a leitura do Qr Code no aplicativo do seu banco ou clique no botão para copiar o código.",
  depositAmount: "Valor do depósito",
  or: "OU",
  repeatThePassword: "A confirmação deve ser igual à senha",
  darkTheme: "Tema escuro",
  administrator: "Administrator",
  reasonFroCancellation: "Motivo cancelamento",
  reason: "Motivo",
  bet: "Aposta",
  witdhdrawalAuthorized: "Autorização de Saque",
  FilteredPeriod: "Período filtrado",
  seller: "Vendedor",
  comissionGerLocal: "Comissão gerente local",
  agentCommissions: "Comissões Agentes",
  assessment: "Apuração",
  oddMargin: "Margem Odd",
  currentCredit: "Crédito Atual",
  retentionLimit: "Limite Retenção",
  rowsPerPage: "Linhas por página:",
  linkedRoutes: "Rotas Vinculadas",
  linkedAgents: "Agentes Vinculados",
  requiredInput: "Campo Obrigatório *",
  allowPixKeyEdit: "Permitir edição de chave Pix",
  linkRoute: "VINCULAR ROTA",
  searchByMarket: "Pesquisar por mercado",
  punter: "Apostador",
  userModifyPixkey: "Permitir que o usuário modifique sua chave pix.",
  pixKey: "CHAVE PIX",
  removeTrack: "Remover faixas",
  remove: "Remover",
  addNewTrack: "Adicionar nova faixa",
  searchToMarket: "Pesquisar por mercado",
  makeDeposit: "Realizar depósito",
  notRegisteredEmail: "E-mail não cadastrado",
  local: "Local",
  regional: "Regional",
  qtySales: "Qtd. Vendas",
  billingEmail: "Email de cobrança",
  eventsPerBetHint:
    "Para suspender as atividades de apostas, coloque o valor 0.00 nesse campo",
  maximumLimitByMarketOnEventTip:
    "Essa configuração é aplicada pra definir quanto cada mercado de um evento pode suportar em apostas online.",
  percentUserCanHighLimitTip:
    "Essa porcentagem é aplicada apenas para os usuários online, serve pra limitar o quanto cada usuário pode utilizar do limite máximo.",
  disabled: "Desativado",
  groosProfit: "Lucro Bruto",
  accountDrawer: "Conta ",
  salesLimit: "Limite de Vendas",
  originalTimeOdds: "Tempo de validar aposta com cotação original (minutos)",
  originalTimeOddsTip:
    "Aceitar alterações de cotação entre a pré-aposta e a validação pelo agente.",
  valueMinAccepted: "O valor mínimo para apostas é R$ 0.50",

  // invoice: "FATURA",
  invoiceNum: "Fatura Nº: ",
  invoiceUseLicense: "SGA.BET - Licença de uso",
  invoiceDesctiption:
    "Discriminação: a renovação do seu plano é mensal, de acordo com o pagamento da fatura aqui apresentada.",
  invoiceServiceProvider: "Provedor de serviço:",
  invoiceBill: "Faturar na conta",
  invoiceAccNumber: "Número de conta:",
  invoiceClient: "Cliente:",
  invoiceDomain: "Domínio:",
  invoiceAddress: "Endereço:",
  invoiceCityState: "Cidade/Estado:",
  invoiceZipcode: "Código postal:",
  invoiceDateStart: "Data de Início",
  invoiceDateEnd: "Data Final",
  invoicePlanDescription: "Descrição do Plano",
  invoiceTotalPrice: "Preço Total (R$)",
  invoiceSubTotal: "SubTotal",
  invoiceAddition: "Adição",
  invoiceDiscount: "Desconto",
  invoiceObservation: "Observação:",
  invoiceThankYou: "Obrigado pela sua preferência!",
  invoiceProductCompany:
    "SGA.BET © Um produto da Empresa TITANS SOFTWARE CORP.",
  unpaidAwards: "Premiadas não pagas",
  idOperation: "ID da Operação",
  consultByRegistrationDate: "Consulta por Data de Cadastro",
  byDeposit: "Por Depósito",
  byBalance: "Por Saldo",
  exactBalance: "Saldo exato",
  balanceGreaterThan: "Saldo maior que:",
  balanceLessThan: "Saldo menor que:",
  inactive: "Inativo",
  qtyDeposits: "Qtd. Depósitos",
  exactQty: "Qtd. exata",
  QtyGreaterThan: "Qtd. maior que:",
  QtyLessThan: "Qtd. menor que:",
  realiabilityFactorTip:
    "Esse fator serve como multiplicador da porcentagem que este usuário pode usar em cada mercado, porcentagem esta, que é definida nas configurações da banca.",
  playerAffiliation: "Afiliação do Jogador",
  marketLimits: "Limites de Mercado",
  byAward: "Por Prêmio",
  exactAward: "Prêmio exato",
  awardGreaterThan: "Prêmio maior que:",
  awardLessThan: "Prêmio menor que:",
  consultLogs: "Consultar Logs",
  byTypeOfUser: "Filtrar tipo de usuário",
  backOffice: "Backoffice",
  logLegend: "Ao encontrar dados, um download automático será realizado.",
  filterAction: "Filtrar Ação",
  inputStringLabel: "Inserir um Login",

  // LOGS
  accountBlocked: "Conta Bloqueada",
  accountSuspended: "Conta Suspensa",
  admPasswordUpdated: "Senha de ADM Atualizada",
  agentCreditAdded: "Crédito de Agente Adicionado",
  agentCreditReseted: "Crédito de Agente Redefinido",
  agentInserted: "Agente Inserido",
  agentPasswordUpdated: "Senha de Agente Atualizada",
  agentRoutesInserted: "Rotas de Agente Inseridas",
  agentRoutesUpdated: "Rotas de Agente Atualizadas",
  agentStatusChanged: "Status de Agente Alterado",
  agentStatusUpdated: "Status de Agente Atualizado",
  agentUpdated: "Agente Atualizado",
  areaInserted: "Área Inserida",
  areaUpdated: "Área Atualizada",
  betCanceledLog: "Aposta Cancelada",
  betPaid: "Aposta Paga Pelo Gerente",
  betPaidByAdm: "Aposta Paga Pelo ADM",
  betValidated: "Aposta Validada",
  bonusChanged: "Bônus Alterado",
  cashoutAuthorizedByAdm: "Saque Autorizado pelo ADM",
  collectorConsolidatedCash: "Caixa do Coletor Consolidado",
  collectorEntryInserted: "Entrada do Coletor Inserida",
  collectorRoutesInserted: "Rotas do Coletor Inseridas",
  collectorUpdated: "Coletor Atualizado",
  comissionsUpdated: "Comissões Atualizadas",
  changedUserStatus: "Status do Usuário Alterado",
  creditCanceled: "Crédito Cancelado",
  creditSold: "Crédito Vendido",
  depositForPlayerBillet: "Boleto para Depósito de Jogador",
  depositOnline: "Depósito Online Paybrokers",
  depositOnlinePay4Fun: "Depósito Online Pay4Fun",
  depositOnlineBrasilCash: "Depósito Online Brasil Cash",
  entryDealInserted: "Acordo de Entrada Inserido",
  eventCanceled: "Evento Cancelado",
  eventMarketChanged: "Mercado do Evento Alterado",
  eventOutcomeUpdated: "Resultado do Evento Atualizado",
  eventStatusChanged: "Status do Evento Alterado",
  invalidLevel: "Nível Inválido",
  localInserted: "Local Inserido",
  localManagerInserted: "Gerente Local Inserido",
  localManagerUpdated: "Gerente Local Atualizado",
  localManagerPasswordUpdated: "Senha de Gerente Local Atualizada",
  localUpdated: "Local Atualizado",
  loginSuccess: "Login Bem-sucedido",
  marketInserted: "Mercado Inserido",
  operatorConfigUpdated: "Configuração do Operador Atualizada",
  operatorOnlineConfigUpdated: "Configuração Online do Operador Atualizada",
  outcomesInserted: "Opção de Mercado Inserido",
  outcomeUpdated: "Valor da Opção de Mercado Atualizado",
  placeBet: "Aposta Realizada",
  playerAddressDataUpdated: "Dados do Endereço do Jogador Atualizados",
  playerBankDataUpdated: "Dados Bancários do Jogador Atualizados",
  playerContactDataUpdated: "Dados de Contato do Jogador Atualizados",
  playerInserted: "Jogador Inserido",
  playerInstantCashout: "Saque Instantâneo do Jogador",
  playerPasswordUpdated: "Senha do Jogador Atualizada",
  playerPersonalDataUpdated: "Dados Pessoais do Jogador Atualizados",
  playerUpdated: "Jogador Atualizado",
  preBetLog: "Pré-aposta",
  insertedRegional: "Regional Inserido",
  regionalPasswordUpdated: "Senha Regional Atualizada",
  regionalUpdated: "Regional Atualizado",
  incompleteRegistration: "Registro Incompleto",
  tournamentEntered: "Torneio Inserido",
  userUpdated: "Usuário Atualizado",
  withdrawIntention: "Intenção de Saque",
  wrongPassword: "Senha Incorreta",
  collectorInserted: "Arrecadador Inserido",
  userStatusUpdated: "Status do Usuário Atualizado",
  legendInactiveAgents: "Agentes que Não Fizeram Aposta nos Ultimos 30 Dias",
  updatedCommissions: "Comissões Atualizadas",
  actionsContributors: "Ações dos Usuários",
  logIntoTheSystem: "Logar no sistema",
  listBetsWinningLosingPending:
    "Listar apostas, premiadas, perdidas, pendentes",
  cancelBets: "Cancelar apostas.",
  listAgents: "Listar agentes",
  activateSuspendConsultAgents: "Criar/Editar/Consultar agentes",
  activateSuspendAgents: "Ativar/Suspender agentes",
  listLocalManagers: "Listar gerentes locais",
  createEditQueryLocal: "Criar/Editar/Consultar gerentes locais",
  activateSuspendLocal: "Ativar/Suspender gerentes locais",
  createEditQueryRoutes: "Criar/Editar/Consultar rotas",
  listCollectors: "Listar arrecadadores",
  createEditConsultCollectors: "Criar/Editar/Consultar arrecadadores",
  viewAgentNetworkFinancial:
    "Visualizar relatórios financeiros de sua rede de agentes, vendas, comissões, prêmios pagos, bruto, líquido",
  viewFinancialStatements:
    "Visualizar balanços financeiros, acertos realizados com arrecadadores e agentes",
  viewAffiliateReports: "Visualizar relatórios de afiliados",
  makeAdjustmentsAndConsolidateThem: "Realizar acertos e consolidá-los",
  accessToTheGeolocationOfAgents:
    "Acesso à geolocalização dos agentes de sua rede",
  noteSomeActionsMayDepend:
    "Nota: Algumas ações podem depender da configuração aplicada em cada usuário",
  viewYourAgentFinancialReport:
    "Visualizar relatórios financeiros de sua rede de agentes, vendas, comissões, prêmios pagos, bruto, líquido",
  listCreditSales: "Listar vendas de créditos",
  changeYourPassword: "Alterar sua senha",
  viewFinancialReportsAgent:
    "Visualizar seus relatórios financeiros, vendas, comissões, prêmios pagos",
  validateVisitorBets:
    "Validar apostas de visitantes, o que chamamos de pré-apostas",
  placeDirectBets: "Realizar apostas diretas",
  sellAndListCreditSales: "Vender créditos e listar vendas de créditos",
  accessEventTable: "Acessar tabela de eventos",
  accessToAWeeklySummary: "Via web, acesso à um resumo semanal (dashboard)",
  affiliatePlayers: "Afiliar jogadores",
  registerCustomers: "Registrar clientes",
  consultTheRoutesToCollect: "Consultar as rotas a coletar",
  consultTheFinancialHistoryOfLinkedAgents:
    "Consultar o histórico financeiro de agentes vinculados",
  performEntriesPayOrReceive: "Realizar lançamentos, pagar ou receber",
  consultEntriesMadeByManager: "Consultar lançamentos realizados pelo gerente",
  actionsRegionalCanPerform: "Ações que o Gerente Regional pode realizar:",
  actionsLocalCanPerform: "Ações que o Gerente Local pode realizar:",
  actionsAgentCanPerform: "Ações que o Agente pode realizar:",
  actionsCollectorCanPerform: "Ações que o Arrecadador pode realizar:",
  betPlacedReport: "Relatório de apostas feitas",
  preMatch: "Pré-evento",
  matchDay: "Dia do Evento",
  prematchAndMatchday: "Pré-evento / Dia do Evento",
  eventDate: "Data do Evento",
  totalOdds: "Total Odds",
  idBet: "ID Aposta",
  cancellation: "Cancelamento",
  betDate: "Data da Aposta",
  reportAllMarkets: "Relatório de todos os mercados",
  totalBets: "Total Apostas",
  totalPrize: "Total Prêmios",
  totalCanceled: "Total Canceladas",
  totalCommissions: "Total Comissões",
  selectCountry: "Selecione um país",
  suspendEvent: "Suspender Evento",
  cancelEvent: "Cancelar evento",
  postponeEvent: "Adiar evento",
  activateEvent: "Ativar evento",
  editOdds: "Editar odds",
  opening: "Abertura",
  closing: "Fechamento",
  weHaveNoBetsOnThisEvent: "Não temos apostas para este evento",
  allMarketsReport: "Relatório de todos os mercados",
  noBetsFountForThisEvent: "Nenhuma aposta encontrada para este evento",
  commissionOnTheGross: "Comissão sobre o Bruto",
  commissionOnTheNgr: "Comissão sobre o NGR",
  commissionType: "Tipo Comissão",
  suspensionDetails: "Detalhes da Suspensão",
  suspensionDate: "Data de suspensão",
  suspendedBy: "Suspenso por",
  PromotionsAndbonus: "Promoções e Bônus",
  dateStart: "Data Inicio",
  dateFinal: "Data Final",
  timeFinal: "Hora Final",
  limitUse: "Limite de Uso",
  percentage: "Porcentagem",
  promotionCode: "Código da Promoção *",
  promotionCodeTableHeader: "Código da Promoção",
  createNewPromotion: "Criar Promoção",
  registerNewPromotion: "Cadastrar nova promoção",
  endTime: "Hora Final",
  typeOfPromotion: "Tipo da promoção",
  typeOfPromotionSelect: "Tipo da promoção *",
  register: "Cadastro",
  noSpacesAreAllowed: "Não são permitidos espaços",
  dateStartGreaterThanEndDate:
    "Data Inicio não pode ser maior que a data final",
  doYouWantToDeactivateThisPromotion: "Deseja Desativar esta promoção?",
  campaing: "Campanha",
  campaings: "Campanhas",
  noCode: "Sem código",
  numberShouldBeGreaterThanZero: "Número deve ser maior que zero!",
  showOrderOptional: "Ordem de aparição (Opcional)",
  insertLinkOptional: "Inserir Link (Opcional)",
  disablePromotion: "Desativar Promoção",
  newCampingMessage:
    "*O usuário só pode participar de uma promoção de cadastro, e a promoção de Afiliados sobreescreve a de Cadastro quando ativas no mesmo período. Para as Campanhas, utilize nomes diferentes.",
  usageDetails: "Detalhes de uso",
  usageAmount: "Quantidade de uso",
  numberOfUses: "Quantidade utilizada",
  promotionTotalBonus: "Total de Bônus da promoção",
  numberOfAvailableUses: "Quantidade disponível",
  maximumNumberOfUses: "Quantidade Máxima de utilizações",
  totalBonusAmountAwarded: "Valor total de Bônus concedido",
  unitaryValue: "Valor Unitário",
  newAffiliate: "Novo Afiliado",
  linkAffiliate: "Link Afiliado",
  casino: "Cassino",
  transactions: "Transações",
  game: "Jogo",
  gameType: "Tipo de Jogo",
  tableGames: "Jogos de Mesa",
  provider: "Provedor",
  casinoSettings: "Configurações do Cassino",
  selectActiveGames: "Escolher Jogos Ativos",
  sport: "Esporte",
  sports: "Esportes",
  createBonus: "Criar Bônus",
  registerNewBonus: "Cadastrar novo bônus",
  cancel: "Cancelar",
  choosePlayerToApplyBonus: "Escolha o jogador para aplicar bônus",
  percentageCashOut: "Porcentagem de Cash Out",
  cashOut: "Encerrar Apostas",
  bonusSettings: "Configurações de Bônus",
  transactionsSettings: "Configurações de Transações",
  onMaintenance: "Site em manutenção",
  onMaintenanceMessage:
    "Para melhor atendimento, estamos em manutenção. Por favor, tente novamente mais tarde.",
  overview: "Visão Geral",
  landingPage: "Landing Page",
  makeYourLandingPage: "Construa sua landing page no editor abaixo.",
  useOurTemplate: "Use nosso template como ponto de partida:",
  loadTemplate: "Carregar Template",
  previewPage: "Ver Página",
  attention: "Atenção",
  cancelPaidBetTitle: "Cancelando Aposta Paga",
  cancelPaidBetContent1:
    "Essa aposta já foi paga, você deseja realmente cancelar?",
  cancelPaidBetContent2:
    "Quando uma aposta já está paga, o valor apostado é estornado e o valor do prêmio é debitado. Para isto, certifique-se que o jogador possua saldo para ser debitado.",
  areYouSureYouWantToCancelTheBonus:
    "Você tem certeza de que deseja cancelar o bônus?",
  cancelBonus: "Cancelar bônus",
  exactDepositValue: "Depósito exato",
  moreThanDepositValue: "Depósito maior que:",
  lessThanDepositValue: "Depósito menor que:",
  byDepositValue: "Por Valor De Depósito",
  duo: "Dupla",
  changeOutcomeEvent: "Odd modificada com sucesso!",
  actionCantBeUndone: "Essa ação não pode ser desfeita!",
  scratch: "Raspadinha",
  liveCasino: "Cassino ao Vivo",
  roulette: "Roleta",
  paymentProvider: "Provedor",
  cantVerifyBank:
    "Não é possível realizar a verificação bancária porque você só tem a Pay4Fun como provedor ativado.",
  continue: "Continuar",
  solicitedWithdrawId: "ID do Saque Solicitado",
  withdraw: "Saque",
  manual: "Manual",
  minDeposit: "O valor mínimo para depósito é R$ {min_stake}.",
  maxDeposit: "O valor máximo para depósito é R$ 20.000.",
  cantDeactivatePaybrokers:
    "Não é possível desativar esse método porque você está com a verificação bancária ativada.",
  paymentProviders: "Provedores de Pagamento",
  seeMethods: "Ver e editar métodos de pagamento",
  wallet: "Carteira Pay4Fun",
  vinculoDeposit: "Vínculo de depósito",
  vinculoDepositTooltip:
    "O vínculo de depósito é uma regra que impede o saque do valor depositado que não foi utilizado para apostas. Com esta opção habilitada, se um jogador depositar $ 100, ele só poderá sacar esse valor depois de ter usado o mesmo valor nas apostas. Com esta opção desabilitada, não haverá geração de vínculo de depósito em depósitos futuros.",
  minBet: "Aposta Mínima *",
  title: "Título",
  promotionTitle: "Título *",
  and: "e",
  rolloverMultiplier: "Multiplicador de Rollover *",
  rolloverMultiplier2: "Multiplicador de Rollover",
  adhesionRules: "Regras de Adesão",
  rolloverRules: "Regras do Rollover",
  promotionImage: "Imagem Da Promoção *",
  promotionImageWithoutAsterisk: "Imagem Da Promoção",
  rewardRules: "Regras de Recompensas",
  validity: "Validade",
  typeAndCodeOfPromotion: "Tipo e Código da Promoção",
  maxTransferTooltip:
    "Determina o valor máximo de transferência de bônus para o saldo real do jogador através desta promoção após cumprimento do rollover.",
  multiRolloverTooltip:
    "Multiplica o VALOR DO BONUS adquirido pela promoção para definir o rollover total a ser cumprido para poder transformar o bonus em saldo real. Ex: Caso o bônus seja de R$ 200,00 e o multiplicador de rollover seja 5x. O rollover total a ser cumprido será de R$ 1000,00",
  daysToRollover:
    "Quantidade de dias que o jogador ou jogadora terá para cumprir o rollover após aderir a promoção.",
  transfers: "Transferências",
  transfer: "Transferência",
  freeRounds: "Rodadas Grátis de Cassino",
  entryId: "ID do Lançamento",
  userName: "Nome do Usuário",
  gainedBonus: "Bônus Ganho",
  transferedCredit: "Crédito Transferido",
  promotionId: "ID da Promoção",
  affiliateId: "ID do Afiliado",
  affiliateName: "Nome do Afiliado",
  copyAffiliateLink: "Copiar Link de Afiliado",
  delete: "Excluir",
  deletePromotion: "Excluindo Promoção",
  areYouSureYouWantToDeleteThePromotion:
    "Você tem certeza de que excluir a promoção? Essa ação é irreversível.",
  deletingPromotionUserRollover:
    "Usuários que já tiverem aderido a essa promoção não serão afetados. Eles poderão concluir o rollover normalmente.",
  updatingPromotion: "Editando Promoção",
  browserCachingImage: `Algumas vezes, o navegador pode "lembrar" da imagem antiga e
  continuar exibindo ela. Para checar a nova imagem, é só atualizar
  a página ou checar a promoção no site. Sua imagem estará sendo
  atualizada normalmente.`,
  promotionLink: "Link da Promoção",
  apurationByCasinoGame: "Apuração de Afiliado por Jogo de Cassino",
  deletingMainEvent: "Excluindo Evento Principal",
  loadingEvents: "Carregando eventos",
  addMainEvent: "Adicionar Evento aos Principais",
  removeMainEvent: "Remover Evento dos Principais",
  noMainEvents:
    "Nenhum evento principal selecionado. Adicione eventos principais em ",
  showMainEvents: "Exibir Eventos Principais?",
  mainEvents: "Eventos Principais",
  mainEventsWhere:
    "Eventos principais são exibidos no topo do seu site, abaixo do carrossel.",
  mainEventsWeFeedIt:
    "Todo dia, nós alimentamos os seus eventos principais com os jogos com mais potencial de apostas.",
  mainEventsFinalUserSees:
    "Os eventos principais podem ser de qualquer esporte. Só serão exibidos para o jogador os eventos de hoje que ainda não foram iniciados.",
  mainEventsYouCanAddHere:
    "Você pode adicionar eventos principais na lista de ",
  prizePercentage: "Porcentagem do Prêmio",
  eventNumberNeededForAgentPrizePercentage: "Número de Eventos Necessários",
  clientGains: "Cliente Recebe",
  savePdf: "Salvar PDF",
  documentVerification: "Verificação Documento",
  verificationOfDocument: "Verificação de Documento",
  loadingPlayers: "Carregando jogadores",
  validatingDocument: "Validando Documento",
  documentFront: "Comprovante de Identidade (Frente)",
  documentVerse: "Comprovante de Identidade (Verso)",
  faceBiometry: "Foto de Rosto",
  confirmPlayerValidation: "Deseja realmente {type} o jogador com ID {userId}?",
  concluded: "Concluído",
  verification: "Verificação",
  documentVerificationTooltip:
    "Você pode analisar documentos que não atingiram o critério de aceitação automática e aprovar a verificação dos usuários.",
  deny: "Negar",
  lowerCaseValidate: "validar",
  lowerCaseDeny: "negar",
  accept: "Aceitar",
  withoutCommission: "Sem Comissionamento",
  variableCommissionSingular: "Comissão Variável",
  fixedCommission: "Comissão Fixa",
  commissionCpa: "Comissionamento por CPA",
  commissionsOnlyInteger:
    "A comissão não pode ser um valor fracionado, apenas inteiro.",
  feeValueOnlyInteger:
    "O valor da taxa não pode ser um valor fracionado, apenas inteiro.",
  variableCommissions: {
    label: "Comissões Variáveis",
    description: `As comissões variáveis são comissões personalizadas, que você pode
    atribuir aos seus afiliados com base no <b>NGR (GGR - Taxa do Afiliado)</b> deles. Caso
    tenha comissões preenchidas e selecione a comissão variável para o
    afiliado, a comissão aplicada nele será a variável.`,
    errors: {
      fromCantBeEqualOrLessThanUntil: `O valor "De:" não pode ser igual ou maior que o valor de "Até:".`,
      from: `O valor de "De:" não pode ser menor ou igual que o valor "Até:" anterior.`,
      fromSuggestion: `O intervalo entre o "Até:" e o "De:" não pode ser maior que 1. Sugerimos colocar o valor {value}.`,
      until: `O valor de "Até:" não pode ser menor que o valor "De:".`,
      comissionBelow0: "A comissão não pode ser inferior a 0.",
      comissionBelowOnli0: "A comissão ao vivo não pode ser inferior a 0.",
      comissionAbove20: "Atenção: comissão maior que 20%.",
      comissionAbove20onli: "Atenção: comissão ao vivo maior que 20%.",
      intValue: "A comissão precisa ser um número inteiro.",
      intValueOnli: "A comissão ao vivo precisa ser um número inteiro.",
    },
  },
  profit: {
    prematch: "Lucro Estimado Pré-Jogo",
    live: "Lucro Estimado Ao Vivo",
    superOdd: "Lucro SuperOdd",
    showSuperOdd: "Exibir SuperOdd no evento",
    tooltip:
      "A SuperOdd exibirá o valor original rasurado e o valor aumentado em destaque quando a margem estiver valorizando (aumentando) a cotação.",
    displayingSuperOdd: "Este mercado está exibindo SuperOdd",
    hidingSuperOdd: "SuperOdd não está sendo exibida",
  },
  commissionEqualOrGreaterThan100:
    "O valor inserido é acima do permitido. O valor máximo para a comissão é de 99%.",
  commissionEqualOrGreaterThan100Onli:
    "O valor inserido é acima do permitido. O valor máximo para a comissão ao vivo é de 99%.",
  feeValueEqualOrGreaterThan100:
    "O valor inserido é acima do permitido. O valor máximo para a taxa é de 99%.",
  commissionValue: "Valor Comissão",
  switchDescription: `Esse campo é o modo de comissão atual do afiliado. <br> Caso ativado,
  o percentual de comissão desse afiliado usado nos cálculos de
  relatórios será a fixa, que é o campo ao lado. <br> Caso desativado,
  a comissão do afiliado será a variável, que pode ser configurada
  na lista de afiliados.`,
  variable: "Variável",
  "2fa": {
    otpSent:
      "Um código foi enviado para seu celular cadastrado. Insira-o aqui.",
    resending: "Reenviando",
    resendCode: "Reenviar Código",
    wait: "Aguarde {seconds}s",
    verify: "Verificar",
    verifying: "Verificando",
    registerPhone: `Como medida de segurança, agora é necessário fazer autenticação em dois
    fatores ao entrar no seu painel. Você não tem um celular cadastrado,
    então precisa cadastrar ele aqui para receber o código de autenticação.`,
    necessaryMeasure: "Medida Necessária",
    confirmPhone:
      "Confirme que esse celular realmente é o seu. Em caso de erro, terá que entrar em contato com o suporte para a mudança do mesmo.",
    choosenPhone: "Celular escolhido: ",
    confirmPhoneTitle: "Confirmar Celular",
    codeRequired: "Código Necessário",
    resendCodeShort: "Reenviar {seconds}s",
  },
  createNewEvent: {
    createEvent: "Criar evento",
    eventCreationTitle: "Criar novo evento",
    leagueCreationTitle: "Criar nova liga",
    drawer: "Meus Eventos",
    description:
      "Meus eventos são eventos personalizados criados por você, com esporte e liga personalizadas. Você também pode definir a cotação dos times, e após o evento finalizar, definir o vencedor.",
    setResult:
      "Você pode definir um vencedor clicando no ícone de pincel na coluna de Ações.",
    creatingEvent: "Criando evento",
    eventCreated: "Evento criado com sucesso!",
    updateResult: "Atualizar Resultado",
    confirmUpdateResult:
      "Atenção! Confirma a seleção de { selectedOdd } como o ganhador do evento?",
    marketInsert: "Mercado: ",
    selectWinnerAlert: {
      hasNotStarted:
        "Não é possível selecionar a odd vencedora pois o evento ainda não começou.",
      finished: "O evento já teve seu vencedor selecionado.",
    },
    form: {
      selectALeague: "Selecionar uma liga",
      registerOdds: "Cadastrar odds",
      registerEvent: "Cadastrar evento",
      teamOne: "Time 1",
      teamTwo: "Time 2",
      leagueName: "Nome da liga",
      riskFactor: "Fator de risco da liga",
      min: "Mínimo",
      med: "Médio",
      max: "Máximo",
      selectWinnerOdd: "Selecionar Odd Vencedora",
      creatingLeague: "Criando liga",
      leagueCreated: "Liga criada com sucesso!",
      riskFactorDescription: `O peso da liga vai influenciar o valor de responsabilidade total do evento. <br/>
      Caso seja máximo, o jogador poderá utilizar a porcentagem que cabe a ele no valor total da responsabilidade no evento. <br/>
      Caso seja médio, ele só poderá apostar metade do valor total da responsabilidade no evento. <br/>
      Caso seja mínimo, haverá grande limitação sobre o valor total da responsabilidade no evento.`,
    },
    errors: {
      selectDay: "Selecione o dia do evento.",
      invalidDay: "A data do evento é inválida.",
      eventDateAlreadyHappened: "O dia do evento já aconteceu.",
      moreThanSevenDays:
        "Não é possível inserir eventos com data de ínicio maior que 7 dias de agora.",
      selectHourAndMinute: "Selecione a hora e o minuto do evento.",
      negativeHour:
        "A hora do evento só pode ser um número positivo entre 0 e 23.",
      wrongHour: "A hora do evento só pode ser um número entre 0 e 23.",
      negativeMinute:
        "O minuto do evento só pode ser um número positivo entre 0 e 59.",
      wrongMinute: "O minuto do evento só pode ser um número entre 0 e 59.",
      creatingEventError:
        "Houve um erro inesperado ao criar o evento. Contate o suporte.",
      noOdds: "Nenhuma cotação disponível para esse mercado.",
    },
  },
  minActivePlayersDescription:
    "Ao definir um mínimo de usuários ativos para o afiliado no período das consultas que forem realizadas, se não houver esse número mínimo, o afiliado não será comissionado. Usuário ativo: fez aposta em esportes ou cassino.",
  payments: {
    tab: "Pagamentos",
    makePayment: "Realizar Pagamentos",
    pay: "Pagar",
    historic: "Histórico",
    loadingAffiliates: "Carregando afiliados",
    noDataFound: "Nenhum dado disponível",
    eligibleForPayment:
      "O afiliado considerado elegível é o que conectou uma conta de jogador a sua conta. <br/> O afiliado pode fazer esse processo digitando a conta e senha da sua conta de jogador, no seu painel em Transferências -> Vincular Jogador.",
    eligible: "Elegível",
    eligiblePlural: "Elegíveis",
    notEligiblePlural: "Não Elegíveis",
    eligibleValue: "Comissão Total (Elegíveis)",
    valueAll: "Comissão Total (Todos)",
    linkedPlayer: "Jogador Vinculado",
    makingPayment: {
      affiliatesBeingPaid: "Afiliados sendo pagos: {count}",
      totalValue: "Valor total:",
    },
    selectElegibleAffiliates: "Selecionar Afiliados Elegíveis",
    removeElegibleAffiliates: "Remover Afiliados Elegíveis",
    invoiceId: "Id da Fatura",
    paymentDate: "Data do Pagamento",
    withInvoice: "Com Fatura",
    withoutInvoice: "Sem Fatura",
  },

  providerRequired: "Selecione um provedor.",
  removed: "Removido",
  freespins: {
    resume: "Resumo de Freespins",
    totalPending: "Total Pendente",
    totalActive: "Total Ativos",
    totalExpired: "Total Expirados",
    totalRemoved: "Total Removidos",
    totalFinalized: "Total Finalizados",
    balanceTotal: "Balanço Total",
    createCampaign: "Criar Campanha",
    claimTooltip: "Lista de usuários que reivindicaram esta campanha",
    name: "Freespins",
    create: "Criar campanha",
    view: "Ver campanha",
    update: "Atualizar campanha",
    roundsQuantity: "Quantidade de rodadas",
    campaignId: "ID campanha",
    loading: "Carregando campanhas",
    adhesionsLoading: "Carregando adesões",
    startDate: "Data/hora início",
    endDate: "Data/hora final",
    inProgress: "Em Progresso",
    progressiveSpins: "Freespins Progressivo",
    progressiveSpinsInfo: `A progressividade nos freespins possibilita que o jogador receba
    uma quantidade de freespins proporcional ao valor depositado.
    Esse número pode variar de 1 a 4 e será utilizado como divisor
    sobre o valor do depósito. Dois exemplos rápidos: <br>
    <ul>
      <li>
        Quando a progressividade é configurada em 1, e o usuário depositar R$ 10, ele receberá 10 freespins. Caso deposite R$ 20, receberá 20 freespins, pois o valor depositado dividido por 1 é ele mesmo.
      </li>
      <li>
        Quando a progressividade é configurada em 2, e o usuário depositar R$ 10, ele receberá 5 freespins. Caso deposite R$ 20, receberá 10 freespins, e assim sucessivamente.
      </li>
    </ul>`,
    progressive: "Progressivo",
    form: {
      subheaders: {
        createYourCampaign: "Crie sua campanha",
        editYourCampaign: "Editar sua campanha",
        campaignConfigurations: "Configurações da campanha",
      },
      campaignTitle: "Título da campanha",
      campaignCode: "Código da campanha",
      campaignType: "Tipo de campanha",
      campaignVisibility: {
        title: "Visibilidade da campanha",
        hide: "Ocultar campanha",
        show: "Exibir campanha",
        tooltip:
          "Ao selecionar essa opção, a campanha será escondida para o usuário final na hora do depósito (caso seja de depósito) e na página de Campanhas, mas ainda poderá ser aderida com o uso do código. {updateMessage}",
        tooltipUpdateMessage:
          "É possível editar essa opção após a criação da campanha.",
        },
      progressiveSpins: "Freespins Progressivo",
      progressiveSpinsDivider: "Freespins Progressivo (Divisor)",
      game: "Jogo",
      users: "Usuários que podem reinvindicar",
      doCSVUpload: "Fazer upload de CSV",
      inputCsvLabel: "Arquivo",
      see: "Ver",
      CSVUploadTip: "O arquivo CSV precisa conter uma coluna 'Id'",
      idColumnEmpty: "A coluna 'id' não existe ou os valores da coluna estão vazios",
      fileNotAllowed: "O arquivo não está em formato .csv",
      rounds: "Quantidade de rodadas",
      roundsHint: "De 1 a 100",
      selectAProvider: "Selecione um provedor",
      daysToExpire: "Dias para expirar",
      startDate: "Data de início",
      startTime: "Hora de início",
      endDate: "Data final",
      endTime: "Hora final",
      manualUsers: "Pesquise jogadores para receberem freespins",
      campaignCodeTip: "Código que o jogador vai usar para aderir a campanha.",
      campaignMinimumDepositTip:
        "Valor mínimo que o apostador precisa depositar para conseguir aderir à campanha.",
      depositBondMultiplier: "Multiplicador de vínculo depósito",
      depositBondMultiplierTooltip:
        "O vínculo de depósito garante que o apostador jogue o valor depositado antes de sacar.<br/>Ao definir um multiplicador, até 5, o jogador terá que jogar o valor do depósito vezes o multiplicador definido antes de conseguir sacar.",
      freeSpinsRolloverInfo: "O multiplicador de rollover garante que o apostador jogue o valor depositado antes de resgatar os freespins.<br/>Ao definir em até 100x, o jogador terá que jogar o valor do depósito, vezes o multiplicador definido antes de resgatar seus freespins."
    },
    campaignTypeOptions: {
      custom: "Personalizado",
      deposit: "Depósito",
      firstDeposit: "Primeiro depósito",
    },
    playersOptions: {
      newUsersLast30Days: "Cadastrados nos últimos 30 dias",
      activeLast30Days: "Ativos nos últimos 30 dias",
      usersWithDeposits: "Ativos que depositaram (Últimos 30 dias)",
      usersWithoutDeposits: "Ativos que não depositaram (Últimos 30 dias)",
      addByIdOrName: "Adicionar por ID, login ou nome",
      addByCsv: "Adicionar por arquivo CSV",
    },
    dateAndHour: "Data e hora de reinvidicação do freespin",
    dateAndHourEnd: "Data e hora de expiração do freespin",
    titleWhatYouWannaDo: "O que deseja fazer?",
    cancelPromotionAndFreespinsAdhered:
      "Cancelar promoção e freespins de todos os jogadores que já aderiram",
    cancelFreespinsAdhered:
      "Cancelar promoção, sem remover as adesões já feitas",
    remove:
      "Tem certeza que deseja remover o jogador <strong>{player}</strong> da campanha de freespin <strong>{title}</strong>?",
    removeAlert: "Essa ação é irreversível.",
    deleteFreespinAlert:
      "Tem certeza que deseja desativar a campanha de freespins <strong>{title}</strong>?",
    removingAdhesion: "Removendo adesão",
    removingFreespin: "Removendo freespin",
    finalFreespinDate: "Data final do freespin: {date}",
    notClaimed: "Não reivindicado",
    totalSelectedPlayers: "Total de jogadores selecionados:",
    selectedPlayers: "Jogadores Selecionados",
    viewSelectedPlayers: "Ver jogadores selecionados",
  },
  firstPasswordRegistration: {
    rules: {
      description: "Sua senha deve atender esses requisitos:",
      oneUppercaseLetter: "É preciso ao menos uma letra maiúscula",
      oneLowercaseLetter: "É preciso ao menos uma letra minúscula",
      oneSpecialCharacter:
        "É preciso ao menos um caractere especial (#?!@$%^&*-)",
      oneNumber: "É preciso ao menos um número",
      eightCharacters: "A senha precisa ter exatamente 8 caracteres",
      confirmation: "A senha e a confirmação devem ser iguais",
    },
  },
  categoryNotFound: "Categoria não encontrada",
  newInvoices: {
    name: "Novas Faturas",
    oldInvoices: "Faturas Antigas",
    appliedValue: "Valor Aplicado",
    readQrCode: "Ler o QR Code",
    copyPixCode: "Copiar código PIX",
    loading: "Carregando faturas...",
    generatePix: "Gerar Pix",
    overdue: "Vencida",
    invoiceValue: "Valor da Fatura",
    feeValue: "Valor Juros",
  },
  fixed: "Fixo",
  cpfTooltip:
    "Este campo é destinado ao CPF do responsável pela operação. Este campo servirá para gerar faturas do sistema, caso precise modificar procure o setor financeiro ou gerente de contas",
  billingEmailTooltip:
    "Este email deve ficar preenchido com um email válido, pois ele será utilizado como remetente para o disparo de emails de confirmação, recuperação de conta entre outros.",
  pixPhysicalPersonAlert:
    "Muito importante: Este pix deve ser pago com uma conta de PF, não pode ser conta PJ.",
  revShareValue: "Valor Rev Share",
  fixedOdd: "Odd Fixa",
  hidePromotionTooltip:
    "Ao selecionar essa opção, a promoção será escondida para o usuário final na hora do depósito (caso seja de depósito) e na página de Promoções, mas ainda poderá ser aderida com o uso do código. {updateMessage}",
  hidePromotionTooltipUpdateMessage:
    "É possível editar essa opção após a criação da promoção.",
  loadingPromotions: "Carregando promoções",
  promotionVisibility: "Visibilidade da promoção",
  visibility: "Visibilidade",
  hidePromotion: "Ocultar promoção",
  hidden: "Oculta",
  displayed: "Exibida",
  createNewWebhook: "Criar novo webhook",
  editWebhook: "Editar webhook",
  loadingWebhooks: "Carregando webhooks",
  marginChangedAlertMessage:
    "A mudança na margem {type} de {oldMargin} para {currentMargin} pode beneficiar usuários na hora do cashout.",
  testWebhook: "Testar webhook",
  whatAreWebhooks: `Webhook é uma tecnologia utilizada para permitir a comunicação entre duas aplicações e enviar notificações em tempo real.
  <br />
  Ao cadastrar um webhook, você receberá uma notificação na URL informada sempre que a ação escolhida for concluída.`,
  unexpectedError: "Um erro inesperado aconteceu.",
  dataBeingSent: "Dados sendo enviados (JSON)",
  response: "Resposta",
  success: "Sucesso",
  error: "Erro",
  hide: "Ocultar",
  emailVerification: {
    name: "Verificação de e-mail no saque",
    button: "Verificar email",
    dialogTitle: "Verificar email de usuário",
    description: "Essa ação tornará o jogador capaz de realizar saques.",
    areYouSure:
      "Tem certeza que deseja verificar o email do jogador? Essa ação não pode ser desfeita.",
    forWithdraws: `Ao selecionar “Sim”, o jogador só poderá efetuar saque se seu e-mail estiver verificado. (Recomendado) 
    Ao selecionar “Não”, o jogador poderá efetuar saque sem verificação prévia.`,
  },
  claims: "Reivindicações",
  multifactor: {
    field: "Verificação de duas etapas",
    tooltip:
      "A verificação de duas etapas permite que seus usuários possam ativar uma camada extra de segurança nas suas contas, recebendo um código em seu celular quando fizer login na plataforma.",
  },
  affiliatesCampaigns: {
    noData: "Não há campanhas ativas. | Não há campanhas inativas.",
    noDataFound: "Nenhuma campanha encontrada.",
    name: "Nome da campanha",
    campaignCode: "Código da campanha",
    affiliateName: "Nome do afiliado",
    numberOfClicks: "Qtd. de cliques",
    numberOfUsers: "Qtd. de usuários",
    socialMedia: "Rede social",
    others: "Outros",
    activate: "Ativar",
    desactivate: "Desativar",
    activateOrDesactivate: "Ativar ou desativar",
    createdDate: "Data de criação",
    updatedDate: "Data de atualização",
  },
  activateOrDesactivateCampaign: {
    title: "Confirmar ação",
    description: {
      activate: "Tem certeza que deseja ativar a campanha: ",
      desactivate: "Tem certeza que deseja desativar a campanha: ",
    },
  },
  sortBy: "Ordenar por",
  activeCampaigns: "Campanhas Ativas",
  desactiveCampaigns: "Campanhas Inativas",
  homePage: {
    field: "Página principal",
    tooltip:
      "Esta é a página que seus visitantes irão ver primeiro ao acessar o seu site.",
  },
  expenses: {
    logs: {
      createExpense: "Criação de Despesa de Afiliado",
      editExpense: "Edição de Despesa de Afiliado",
      removeExpense: "Remoção de Despesa de Afiliado",
    },
  },
  resultsPlurals: "resultado | resultados",
  usersPlurals: "Usuário | Usuários",
  depositsPlurals: "Depósito | Depósitos",
  withdrawalsPlurals: "Saque | Saques",
  noQuery: "Nenhuma consulta realizada",
  lastLogin: "Último login",
  birthday: "Nascimento",
  noDataText: "Não há dados",
  noResultsText: "Não há dados para essa pesquisa",
  finishedIn: "Finaliza em",
  withdrawalStatus: {
    requested: "Solicitado",
    authorized: "Autorizado",
    consolidated: "Consolidado",
    cancelled: "Cancelado",
  },
  lastBetTime: "Horário da última aposta",
};
export default pt;
